export const pharmacyFallbacks: Record<string, Record<string, string>> = {
  fr: {
    // --- Pre-pack receiving & hardware catalog (auto-added) ---
    '20L Drum / Bucket': 'Fût / Seau de 20 L',
    '5L Bucket / Can': 'Seau / Bidon de 5 L',
    'Are you sure you want to delete': 'Voulez-vous vraiment supprimer',
    'Are you sure you want to delete category': 'Voulez-vous vraiment supprimer la catégorie',
    'Article Name': 'Nom de l\'Article',
    'Bag / Sack (bag)': 'Sac (sac)',
    'Box (box)': 'Boîte (boîte)',
    'Bundle / Coil (bdl)': 'Lot / Bobine (lot)',
    'Calculate cut length and charge': 'Calculer la longueur de coupe et le montant',
    'Cancel Edit': 'Annuler la Modification',
    'Category deleted successfully': 'Catégorie supprimée avec succès',
    'Category updated successfully': 'Catégorie mise à jour avec succès',
    'Centimeter (cm)': 'Centimètre (cm)',
    'Cost': 'Coût',
    'Cost price is required': 'Le prix d\'achat est requis',
    'Cut': 'Couper',
    'Cut Spool': 'Couper le Touret',
    'Cut of': 'Coupe de',
    'Cut-to-Length Spool': 'Touret à Couper sur Mesure',
    'Cut-to-Length Spool (Touret)': 'Touret à Couper sur Mesure (Touret)',
    'Cut-to-Length Spool?': 'Touret à Couper sur Mesure ?',
    'Delete Hardware Item': 'Supprimer l\'Article Quincaillerie',
    'Delete Item': 'Supprimer l\'Article',
    'Dynamic category created successfully': 'Catégorie dynamique créée avec succès',
    'Edit Hardware Item': 'Modifier l\'Article Quincaillerie',
    'Edit Item': 'Modifier l\'Article',
    'Failed to create hardware item': 'Échec de la création de l\'article de quincaillerie',
    'Failed to delete category': 'Échec de la suppression de la catégorie',
    'Failed to delete item': 'Échec de la suppression de l\'article',
    'Failed to load hardware items catalog': 'Échec du chargement du catalogue de quincaillerie',
    'Failed to log cut stock': 'Échec de l\'enregistrement de la coupe de stock',
    'Failed to save category': 'Échec de l\'enregistrement de la catégorie',
    'Failed to update hardware item': 'Échec de la mise à jour de l\'article de quincaillerie',
    'Feet (ft)': 'Pied (ft)',
    'Full Spool Length (Meters)': 'Longueur Totale du Touret (Mètres)',
    'Gallon (gal)': 'Gallon (gal)',
    'Gram (g)': 'Gramme (g)',
    'Hardware catalog item created successfully': 'Article du catalogue quincaillerie créé avec succès',
    'Hardware catalog item deleted successfully': 'Article du catalogue quincaillerie supprimé avec succès',
    'Hardware catalog item updated successfully': 'Article du catalogue quincaillerie mis à jour avec succès',
    'Import Excel': 'Importer Excel',
    'Inch (in)': 'Pouce (po)',
    'Liter (L)': 'Litre (L)',
    'Metric Ton (t)': 'Tonne métrique (t)',
    'Milliliter (mL)': 'Millilitre (mL)',
    'No items found': 'Aucun article trouvé',
    'No matching categories found': 'Aucune catégorie correspondante',
    'Pair (pr)': 'Paire (pr)',
    'Part # / Reference': 'N° de Pièce / Référence',
    'Piece (pcs)': 'Pièce (pcs)',
    'Pound (lb)': 'Livre (lb)',
    'Processing...': 'Traitement en cours...',
    'Rebar / Length (6m)': 'Fer à béton / Longueur (6 m)',
    'Restock PO': 'Bon de Réapprovisionnement',
    'Retail Selling Price': 'Prix de Vente au Détail',
    'Retail price is required': 'Le prix de vente est requis',
    'Search part #, item name, category...': 'Rechercher n° de pièce, nom, catégorie...',
    'Select category': 'Sélectionner une catégorie',
    'Set / Kit (set)': 'Ensemble / Kit (ens.)',
    'Sheet / Panel (sht)': 'Feuille / Panneau (feuille)',
    'Standard Piece / Bag': 'Pièce / Sac Standard',
    'Stock Level': 'Niveau de Stock',
    'Stock Quantity': 'Quantité en Stock',
    'Stock quantity is required': 'La quantité en stock est requise',
    'Update SKU details, spool specifications, pricing, and stock level': 'Mettre à jour les détails du SKU, les spécifications du touret, les prix et le niveau de stock',
    'Yard (yd)': 'Yard (yd)',
    'logged and spool stock updated successfully': 'enregistrée et stock du touret mis à jour avec succès',
    '⚖️ Weight & Mass': '⚖️ Poids & Masse',
    '📏 Length & Dimensional': '📏 Longueur & Dimensions',
    '📦 Discrete, Bulk & Packaging': '📦 Unités, Vrac & Emballage',
    '🧪 Volume & Liquids': '🧪 Volume & Liquides',
    'e.g. Hydraulic Fittings': 'ex. Raccords hydrauliques',
    'e.g. High-pressure hydraulic hoses & brass fittings': 'ex. Flexibles hydrauliques haute pression et raccords en laiton',
    'e.g. HW-9002': 'ex. HW-9002',
    'e.g. 12-Gauge Copper Cable Spool': 'ex. Touret de câble en cuivre 2,5 mm²',
    'Failed to load pre-pack shipments ledger': 'Échec du chargement du registre des expéditions pre-pack',
    'Failed to record shipment': 'Échec de l\'enregistrement de l\'expédition',
    'Pre-pack carton shipment received successfully': 'Expédition de cartons pre-pack reçue avec succès',
    'Factory Ratio Carton Inventory Receiving': 'Réception d\'Inventaire de Cartons à Ratio d\'Usine',
    'Cartons': 'Cartons',
    'Carton': 'Carton',
    'Pairs': 'Paires',
    'Shipments': 'Expéditions',
    'shipments': 'expéditions',
    'cartons': 'cartons',
    'Showing': 'Affichage de',
    'carton(s)': 'carton(s)',
    'into inventory!': 'dans l\'inventaire !',
    'Failed to unpack carton shipment': 'Échec du déballage de l\'expédition de cartons',
    'Deleted pre-pack shipment': 'Expédition pre-pack supprimée',
    'Failed to delete shipment record': 'Échec de la suppression de l\'enregistrement d\'expédition',
    'Copied Pack ID': 'ID du pack copié',
    'Search Pack ID, Assortment, Brand, Supplier...': 'Rechercher ID de pack, assortiment, marque, fournisseur...',
    'No pre-pack cartons received yet. Click "Receive Shipment" to add one.': 'Aucun carton pre-pack reçu pour le moment. Cliquez sur « Recevoir l\'Expédition » pour en ajouter un.',
    'Pack ID & Assortment': 'ID du Pack & Assortiment',
    'Generic': 'Générique',
    'Copy Pack ID': 'Copier l\'ID du pack',
    'Standard Supplier': 'Fournisseur Standard',
    'Cartons & Ratio Matrix': 'Cartons & Matrice de Ratios',
    'Ratio': 'Ratio',
    'Cost / Carton': 'Coût / Carton',
    'View Size Ratio Breakdown': 'Voir la répartition des pointures',
    'Unpack & Stock': 'Déballer & Stocker',
    'Delete Carton Shipment?': 'Supprimer l\'expédition de cartons ?',
    'Are you sure you want to remove this pre-pack carton record?': 'Voulez-vous vraiment supprimer cet enregistrement de carton pre-pack ?',
    'Ratio Matrix': 'Matrice de Ratios',
    'Per-Carton Size Quantity Distribution': 'Répartition des quantités par pointure et par carton',
    'Covered': 'Couvert',
    'prs': 'pr.',
    'Unpack Cartons & Add to Inventory': 'Déballer les Cartons & Ajouter à l\'Inventaire',
    'Receive Pre-Pack Carton Shipment': 'Recevoir une Expédition de Cartons Pre-Pack',
    'Footwear Model': 'Modèle de Chaussure',
    'Please select a footwear model': 'Veuillez sélectionner un modèle de chaussure',
    'Select registered footwear model...': 'Sélectionner un modèle de chaussure enregistré...',
    'Number of Cartons': 'Nombre de Cartons',
    'Cost per Carton ($)': 'Coût par Carton ($)',
    'This field is required': 'Ce champ est obligatoire',
    'Supplier / Distributor': 'Fournisseur / Distributeur',
    'e.g. Adidas Direct Distribution': 'ex. Adidas Direct Distribution',
    'Size Ratio Distribution Formula': 'Formule de Répartition du Ratio de Pointures',
    'Standard Men (1:2:3:3:2:1 — 12 pairs: EU 40-45)': 'Homme Standard (1:2:3:3:2:1 — 12 paires : EU 40-45)',
    'Standard Women (2:3:3:2 — 10 pairs: EU 36-40)': 'Femme Standard (2:3:3:2 — 10 paires : EU 36-40)',
    'Kids Assortment (2:2:2:2 — 8 pairs: EU 28-34)': 'Assortiment Enfant (2:2:2:2 — 8 paires : EU 28-34)',
    'Record Carton Shipment': 'Enregistrer l\'Expédition de Cartons',
    // ─── Pharmacy Sales History ─────────────────────────────────────────
    'Pharmacy Sales History': 'Historique des Ventes Pharmacie',
    'View, filter, reprint receipts, and track all pharmacy sales transactions.': 'Consultez, filtrez, réimprimez des reçus et suivez toutes les transactions de vente de la pharmacie.',
    'Filtered Sales Revenue': 'Chiffre d\'Affaires des Ventes Filtrées',
    'Total Transactions': 'Total des Transactions',
    'Avg Basket Value': 'Panier Moyen',
    'Cash vs Electronic': 'Espèces vs Électronique',
    'Digital': 'Numérique',
    'All Payment Methods': 'Toutes les Méthodes de Paiement',
    'Sale Receipt': 'Reçu de Vente',
    'Purchased Items': 'Articles Achetés',
    'Pharmacist / Dispenser': 'Pharmacien / Dispensateur',
    'Total Paid': 'Total Payé',
    'Print Receipt': 'Imprimer le Reçu',

    // ─── Login, Register & Auth Pages ─────────────────────────────────
    'Smart Management for': 'Gestion Intelligente pour',
    'Modern Businesses': 'les Entreprises Modernes',
    'Empower your team, manage stores, track sales, and streamline operations in one simple, unified platform.': 'Autonomisez votre équipe, gérez vos magasins, suivez vos ventes et simplifiez vos opérations au sein d\'une seule et même plateforme.',
    'Please enter your credentials to log in.': 'Veuillez saisir vos identifiants pour vous connecter.',
    'Microservices Monitor': 'Moniteur de Microservices',
    'Background Sync Queue': 'File de Synchro en Arrière-plan',
    'Idle': 'Inactif',
    'Start managing your operations and sales in minutes.': 'Commencez à gérer vos opérations et vos ventes en quelques minutes.',
    'Company profile': 'Profil de l\'entreprise',
    'Primary contact': 'Contact principal',
    'Secure password': 'Mot de passe sécurisé',
    'Business': 'Entreprise',
    'Contact': 'Contact',
    'Security': 'Sécurité',
    'Clinic': 'Clinique',

    // ─── General Technical Pharmacy Terms & Drug Fields ──────────────────
    'Medication': 'Médicament',
    'Medications': 'Médicaments',
    'Medication Inventory': 'Inventaire des Médicaments',
    'Add Medication': 'Ajouter un Médicament',
    'New Medication': 'Nouveau Médicament',
    'Edit Medication': 'Modifier le Médicament',
    'Delete Medication': 'Supprimer le Médicament',
    'Import Medications': 'Importer des Médicaments',
    'Generic Name': 'Nom Générique',
    'Brand Name': 'Nom Commercial',
    'Dosage Form': 'Forme Galénique',
    'Strength': 'Dosage / Concentration',
    'Therapeutic Category': 'Classe Thérapeutique',
    'Active Ingredient': 'Principe Actif',
    'Barcode / SKU': 'Code-barres / SKU',
    'SKU': 'SKU / Référence',
    'Package Size': 'Taille du Conditionnement',
    'Unit of Measure': 'Unité de Mesure',
    'Units': 'Unités',
    'Min Stock Level': 'Niveau de Stock Minimum',
    'Reorder Level': 'Seuil de Réapprovisionnement',
    'Max Stock Level': 'Niveau de Stock Maximum',
    'Cost Price': 'Prix d\'Achat',
    'Selling Price': 'Prix de Vente',
    'Unit Cost': 'Coût Unitaire',
    'Unit Price': 'Prix Unitaire',
    'Cost Per Unit': 'Coût Unitaire',
    'Cost/Unit': 'Coût/Unité',
    'Prescription Required': 'Ordonnance Requise',
    'Over The Counter (OTC)': 'Vente Libre (OTC)',
    'Controlled Substance': 'Substance Contrôlée',
    'Storage Conditions': 'Conditions de Conservation',
    'Room Temperature': 'Température Ambiante',
    'Refrigerated (2-8°C)': 'Réfrigéré (2-8°C)',
    'Frozen': 'Congelé',
    'Cool & Dry Place': 'Lieu Frais & Sec',
    'e.g., GlaxoSmithKline': 'ex., GlaxoSmithKline',
    'e.g., United Kingdom': 'ex., Royaume-Uni',
    'Scan or enter barcode': 'Scanner ou saisir le code-barres',
    'Clinical Information': 'Informations Cliniques',
    'Description': 'Description',
    'Route of Administration': 'Voie d\'Administration',
    'Drug Type (Clinical Classification)': 'Type de Médicament (Classification Clinique)',
    'Select dosage form': 'Sélectionner la forme galénique',
    'Enter strength': 'Saisir le dosage',

    // ─── Prescription Print Slip ──────────────────────────────────────
    'OFFICIAL PRESCRIPTION SLIP': 'ORDONNANCE MÉDICALE OFFICIELLE',
    'Rx Number:': 'N° Ordonnance :',
    'Patient Name:': 'Nom du Patient :',
    'Patient ID:': 'ID Patient :',
    'Doctor Name:': 'Nom du Médecin :',
    'License Number:': 'Numéro de Licence :',
    'MEDICATION': 'MÉDICAMENT',
    'DOSAGE': 'POSOLOGIE',
    'FREQUENCY': 'FRÉQUENCE',
    'DURATION': 'DURÉE',
    'QUANTITY': 'QUANTITÉ',
    'Prepared By:': 'Préparé par :',
    'Prescriber Signature:': 'Signature du Prescripteur :',
    'Stamp / Date:': 'Cachet / Date :',
    'This is a computer-generated clinical prescription document powered by Fuko Systems.': 'Ceci est un document d\'ordonnance clinique généré par ordinateur propulsé par Fuko Systems.',

    // ─── Pharmacy Dashboard ───────────────────────────────────────────
    'View Report': 'Voir le Rapport',
    'No medications expiring soon': 'Aucun médicament proche de la péremption',
    'Stock:': 'Stock :',
    'Min:': 'Min :',
    'cancelled': 'annulée',
    'dispensed': 'délivrée',

    // ─── POS & History Reports ────────────────────────────────────────
    'Search by patient name or prescription number above': 'Recherchez par nom de patient ou numéro d\'ordonnance ci-dessus',
    'History & Daily Report': 'Historique & Rapport Journalier',
    'Sale Number': 'N° de Vente',
    'Customer': 'Client',
    'Walk-in Customer': 'Client de Passage',
    'Search by receipt number, client...': 'Rechercher par n° de reçu, client...',
    'Receipt': 'Facture',
    'Action': 'Action',

    // ─── Branch Management & Edit Branch Modal ─────────────────────────
    'Edit Branch': 'Modifier la Succursale',
    'Create Branch': 'Créer la Succursale',
    'Add Branch': 'Ajouter une Succursale',
    'Update Branch': 'Mettre à jour la Succursale',
    'Update the details of your branch below.': 'Mettez à jour les détails de votre succursale ci-dessous.',
    'Add a new physical branch to your shop.': 'Ajoutez une nouvelle succursale physique à votre boutique.',
    'Branch Manager': 'Gérant de la Succursale',
    'Default Tax Rate (%)': 'Taux de Taxe par Défaut (%)',
    'Select a manager': 'Sélectionner un gérant',
    'E.g. Downtown Branch': 'ex. Succursale Centre-ville',

    // ─── Suppliers & Vendor Management ───────────────────────────────
    'Supplier Name': 'Nom du Fournisseur',
    'Email': 'Email',
    'email': 'Email',
    'Contact First Name': 'Prénom du Contact',
    'Contact Last Name': 'Nom de Famille du Contact',
    'Alternative Phone': 'Téléphone Alternative',
    'State/Province': 'État / Province',
    'Postal/Zip Code': 'Code Postal / Zip',
    'Tax ID / VAT': 'Identifiant Fiscal / TVA',
    'Enter alternative phone': 'Entrez un autre numéro',
    'Enter street address': 'Entrez l\'adresse',
    'Enter state': 'Entrez l\'état / province',
    'Enter country': 'Entrez le pays',
    'Enter postal code': 'Entrez le code postal',
    'Enter Tax ID': 'Entrez le numéro d\'identification fiscale',
    'e.g. Net 30, COD': 'ex. Net 30, COD',
    'Enter limit': 'Entrez la limite',

    // ─── Expiry & Reports ─────────────────────────────────────────────
    'days left': 'jours restants',
    'days ago': 'jours passés',

    // ─── Pharmacist Profile Drawer ───────────────────────────────────
    'Add Pharmacist Profile': 'Ajouter un Profil de Pharmacien',
    'Edit Pharmacist Profile': 'Modifier le Profil de Pharmacien',
    'System User Linkage': 'Lien Utilisateur Système',
    'Search system users...': 'Rechercher des utilisateurs système...',
    'Link this professional profile to an existing system user/login.': 'Lier ce profil professionnel à un utilisateur système existant.',
    'Professional Licensing': 'Licence Professionnelle',
    'e.g., PH-123456': 'ex., PH-123456',
    'e.g., Pharmacy Board': 'ex., Conseil de la Pharmacie',
    'e.g., Rwanda': 'ex., Rwanda',
    'Qualifications & Experience': 'Qualifications & Expérience',
    'e.g., B.Pharm, Clinical Pharmacy Specialist': 'ex., B.Pharm, Spécialiste en Pharmacie Clinique',

    // ─── HR & Employee Management ────────────────────────────────────
    'Manage your staff records and contracts': 'Gérez les dossiers de votre personnel et leurs contrats',
    'Add Employee': 'Ajouter un Employé',
    'Employee': 'Employé',
    'Position': 'Poste',
    'Department': 'Département',
    'Salary': 'Salaire',
    'Actions': 'Actions',
    'Manager, Chef, Pharmacist...': 'Gérant, Chef, Pharmacien...',
    'Kitchen, Sales, Pharmacy...': 'Cuisine, Ventes, Pharmacie...',

    // ─── Payroll & Payroll Hub ──────────────────────────────────────
    'Active Employees': 'Employés Actifs',
    'Active Medical Staff': 'Personnel Médical Actif',
    'Active contracts': 'Contrats actifs',
    'Payroll Paid (Year)': 'Paie Payée (Année)',
    'Total Medical Compensation (Year)': 'Rémunération Médicale Totale (Année)',
    'Cumulative paid': 'Cumul des paiements',
    'Unpaid Advances': 'Avances Non Payées',
    'Pending review': 'En attente d\'examen',
    'Total Disbursement': 'Déboursement Total',
    'Active session disbursements': 'Paiements de la session active',
    'Generate': 'Générer',
    'Internal notes for this payment...': 'Notes internes pour ce paiement...',

    // ─── Unit Configuration & Product Units ─────────────────────────────
    'Unit Configuration': 'Configuration des Unités',
    'Base Price': 'Prix de Base',
    'Total Stock': 'Stock Total',
    'How Unit Selling Works': 'Fonctionnement de la Vente par Unité',
    '1. Define Unit': '1. Définir l\'Unité',
    'Box = 10 Piece': 'Boîte = 10 Pièces',
    '2. Auto Price': '2. Prix Automatique',
    'Box = 800 × 10': 'Boîte = 800 × 10',
    '3. Sell by Unit': '3. Vente par Unité',
    '1 Box → -10 Piece': '1 Boîte → -10 Pièces',
    'Configured Units': 'Unités Configurées',
    'No units configured': 'Aucune unité configurée',
    'Add units to sell in different quantities': 'Ajoutez des unités pour vendre dans différentes quantités',

    // Hardware Analytics & Reports Mobile French Translations
    'Hardware Sales & Rental Analytics': 'Analyses des Ventes & Locations',
    'Performance insights, POS transaction volume, tool rental revenue, and active SKUs': 'Aperçu des performances, volume POS, revenus de location et SKUs actifs',
    'Hardware Inventory & Asset Valuation Report': 'Rapports d\'Inventaire & Valorisation des Actifs',
    'Consolidated asset valuation, cable spool inventory counts, and machinery rental earnings': 'Valorisation consolidée des actifs, comptage des tourets et revenus de location',
    'Total Gross Revenue': 'Revenu Brut Total',
    'Total Sales Transactions': 'Total des Transactions',
    'Equipment Rentals Count': 'Nombre de Locations',
    'Active Inventory SKUs': 'SKUs Actifs en Stock',
    'Category Sales Revenue Distribution': 'Répartition des Ventes par Catégorie',
    'POS Sales Transactions History': 'Historique des Ventes POS',
    'Equipment Rentals Activity': 'Activités de Location',
    'Total Hardware SKUs': 'Total SKUs Quincaillerie',
    'Inventory Asset Value': 'Valeur du Stock d\'Inventaire',
    'Cable / Pipe Spools': 'Tourets de Câbles / Tuyaux',
    'Total Rental Revenue': 'Revenu Total de Location',
    'All Catalog Inventory & Asset Valuation': 'Tout l\'Inventaire & Valorisation des Stocks',
    'Cut-to-Length Cable & Pipe Spools': 'Tourets de Câbles & Tuyaux au Mètre',
    'Search hardware items by SKU, name, category...': 'Rechercher par SKU, nom, catégorie...',
    'Export CSV Report': 'Exporter le Rapport CSV',

    // ─── Purchase Orders (POs) & Detail View ─────────────────────────────
    'Purchase Orders': 'Bons de Commande',
    'Purchase Order': 'Bon de Commande',
    'Purchase Order Details': 'Détails du Bon de Commande',
    'New Purchase Order': 'Nouveau Bon de Commande',
    'Create Purchase Order': 'Créer un Bon de Commande',
    'Edit Purchase Order': 'Modifier le Bon de Commande',
    'Update Purchase Order': 'Mettre à jour le Bon de Commande',
    'View Purchase Order': 'Consulter le Bon de Commande',
    'Generate a pharmacy inventory requisition request for supplier fulfillment': 'Générer une demande de réquisition d\'inventaire de pharmacie pour l\'exécution par le fournisseur',
    'Order & Supplier Information': 'Informations sur la Commande & Fournisseur',
    'Payment & Requisition Notes': 'Notes de Paiement & Réquisition',
    'Select payment terms': 'Sélectionner les conditions de paiement',
    'Select branch': 'Sélectionner la branche',
    'Select supplier': 'Sélectionner le fournisseur',
    'e.g. QUOTE-2026-001': 'ex. DEVIS-2026-001',
    'Automated Smart Re-Order PO for low stock items': 'Commande intelligente automatisée pour les articles en stock faible',
    'Enter notes regarding this requisition order...': 'Saisissez des notes concernant cette demande de réquisition...',
    'Immediate': 'Immédiat',
    'Net 7 Days': 'Net 7 jours',
    'Net 15 Days': 'Net 15 jours',
    'Net 30 Days': 'Net 30 jours',
    'Net 60 Days': 'Net 60 jours',
    'PO Number': 'N° de Bon de Commande',
    'Destination Branch': 'Branche de Destination',
    'Supplier / Vendor': 'Fournisseur / Vendeur',
    'Supplier': 'Fournisseur',
    'Order Date': 'Date de Commande',
    'Expected Delivery Date': 'Date de Livraison Prévue',
    'Expected Delivery': 'Livraison Prévue',
    'Supplier Reference / Quote #': 'Référence Fournisseur / N° Devis',
    'Quote / Ref #': 'N° Devis / Réf.',
    'Urgency / Priority Level': 'Niveau d\'Urgence / Priorité',
    'Priority': 'Priorité',
    'Urgent': 'Urgent',
    'High': 'Élevé',
    'Medium': 'Moyen',
    'Low': 'Faible',
    'Draft': 'Brouillon',
    'Pending Approval': 'En Attente d\'Approbation',
    'Approved': 'Approuvé',
    'Ordered': 'Commandé',
    'Partially Received': 'Partiellement Reçu',
    'Received': 'Reçu',
    'Cancelled': 'Annulé',
    'Payment Terms': 'Conditions de Paiement',

    // ─── Hardware Catalog & Spool Cut Modals ──────────────────────────────
    'Procurement Restock & Delivery Note': 'Réapprovisionnement & Bon de Livraison',
    'Restock Spool Length Added': 'Longueur de Touret Ajoutée',
    'Restock Quantity Added': 'Quantité Réapprovisionnée',
    'Unit Cost Price (Purchase Rate)': 'Prix de Revient Unitaire (Achat)',
    'Unit Retail Price (Selling Rate)': 'Prix de Vente Unitaire (Détail)',
    'Procurement & Inspection Notes': 'Notes de Réapprovisionnement & Inspection',
    'Total Procurement Expense': 'Dépense Totale d\'Approvisionnement',
    'Confirm & Add Stock': 'Confirmer & Ajouter au Stock',
    'Dimensional Spool Cut Calculator': 'Calculateur de Coupe de Touret',
    'Spool Remainder Status': 'Statut du Reste de Touret',
    'Remaining after cut': 'Reste après coupe',
    'Calculated Cut Charge': 'Frais de Coupe Calculés',
    'Execute Cut & Deduct Stock': 'Exécuter la Coupe & Déduire du Stock',
    'Auto-logs Expense Ledger': 'Comptabilisation Automatique',
    'Item Identification & Category': 'Identification de l\'Article & Catégorie',
    'Stock Type & Inventory Control': 'Type de Stock & Contrôle d\'Inventaire',
    'Pricing & Financial Margins': 'Prix & Marges Financières',
    'Supplier / Vendor Name': 'Nom du Fournisseur / Vendeur',
    'Delivery Note Reference (DN)': 'Référence du Bon de Livraison (BL)',
    'Purchase Order # (PO)': 'N° du Bon de Commande (BC)',
    'Manage Business Categories': 'Gérer les Catégories d\'Activité',
    'Organize hardware stock, spools, machinery, and building materials into dynamic categories': 'Organiser le stock de quincaillerie, tourets, machines et matériaux en catégories dynamiques',
    'Create New Category': 'Créer une Nouvelle Catégorie',
    'Edit Category': 'Modifier la Catégorie',
    'Category Description': 'Description de la Catégorie',
    'Create Category': 'Créer la Catégorie',
    'Category Directory': 'Répertoire des Catégories',
    'Add Hardware Catalog Item': 'Ajouter un Article au Catalogue Quincaillerie',
    'Register a new SKU, wire spool stock, or building material to inventory': 'Enregistrer un nouveau SKU, touret de fil ou matériau de construction dans l\'inventaire',
    'Save Hardware Item': 'Enregistrer l\'Article Quincaillerie',
    'Requisition Notes': 'Notes de Réquisition',
    'Requested Medications': 'Médicaments Demandés',
    'Quantity Ordered': 'Quantité Commandée',
    'Financial Summary': 'Résumé Financier',
    'Total Requisition Amount': 'Montant Total de la Réquisition',
    'Metadata & Status': 'Métadonnées & Statut',
    'Requisition Items': 'Articles de Réquisition',
    'Requisition items': 'Articles de Réquisition',
    'Workflow Actions': 'Actions de Flux de Travail',
    'Routing & Logistics': 'Acheminement & Logistique',
    'Search and add medication to purchase order...': 'Rechercher et ajouter un médicament au bon de commande...',
    'Estimated Requisition Total': 'Total Estimé de la Commande',
    'Submit for Approval': 'Soumettre pour Approbation',
    'Submit Purchase Order': 'Soumettre le Bon de Commande',
    'Approve Purchase Order': 'Approuver le Bon de Commande',
    'Reject Purchase Order': 'Rejeter le Bon de Commande',
    'Cancel Requisition': 'Annuler la Réquisition',
    'Cancel Purchase Order': 'Annuler le Bon de Commande',
    'Total POs': 'Total des Bons de Commande',
    'Total Value': 'Valeur Totale',
    'PO Summary': 'Résumé du Bon de Commande',
    'Search PO number, supplier, reference or notes...': 'Rechercher par n° de bon, fournisseur, référence ou notes...',
    'Filter by priority': 'Filtrer par priorité',
    'Filter by status': 'Filtrer par statut',

    // ─── Goods Receiving Notes (GRNs) ──────────────────────────────────
    'Goods Receiving': 'Réception de Marchandises',
    'Goods Receiving Notes': 'Bons de Réception de Marchandises',
    'New Goods Receiving Note': 'Nouveau Bon de Réception',
    'Create Goods Receiving Note': 'Créer un Bon de Réception',
    'Reception Number': 'N° de Réception',
    'Reception No': 'N° Réception',
    'Delivery Note Number': 'N° de Bon de Livraison',
    'Quality Control': 'Contrôle Qualité',
    'Quality Control Status': 'Statut du Contrôle Qualité',
    'Quality status': 'Statut Qualité',
    'Inventory Status': 'Statut des Stocks',
    'Perform Quality Check': 'Effectuer le Contrôle Qualité',
    'Submit Quality Check': 'Soumettre le Contrôle Qualité',
    'Submit Check': 'Soumettre le Contrôle',
    'Post to Inventory': 'Comptabiliser en Stock',
    'Passed QC': 'CQ Conforme',
    'Failed QC': 'CQ Non-Conforme',
    'Quarantined': 'En Quarantaine',
    'Posted to Stock': 'Comptabilisé en Stock',
    'Pending Stock Post': 'En Attente de Comptabilisation',
    'Received Quantity': 'Quantité Reçue',
    'Damaged Quantity': 'Quantité Endommagée',
    'Accepted Quantity': 'Quantité Acceptée',
    'Received Qty': 'Qté Reçue',
    'Batch Number': 'Numéro de Lot',
    'Expiry Date': 'Date de Péremption',
    'Expiry': 'Péremption',
    'Total GRNs': 'Total des Bons de Réception',

    // ─── Batches & Expiry Management ────────────────────────────────────
    'Medication Batches': 'Lots de Médicaments',
    'Track medication batches, expiry dates, and stock levels': 'Suivez les lots de médicaments, dates d\'expiration et niveaux de stock',
    'Batches & Expiry': 'Lots & Expiration',
    'Batch Inventory': 'Inventaire des Lots',
    'Total Batches': 'Total des Lots',
    'Across active branch stock': 'Sur le stock actif des branches',
    'Critical Expiry': 'Péremption Critique',
    'Expiring within 30 days': 'Expire dans les 30 jours',
    'Value at Risk': 'Valeur à Risque',
    'Potential financial loss': 'Perte financière potentielle',
    'Active inventory worth': 'Valeur de l\'inventaire actif',
    'Search batches...': 'Rechercher des lots...',
    'Expiry Window': 'Fenêtre de Péremption',
    'Add Batch': 'Ajouter un Lot',
    'Add New Batch': 'Ajouter un Nouveau Lot',
    'Create Batch': 'Créer un Lot',
    'Adjust Batch': 'Ajuster le Lot',
    'Adjust Batch Quantity': 'Ajuster la Quantité du Lot',
    'Stock Adjustment': 'Ajustement de Stock',
    'Adjustment Type': 'Type d\'Ajustement',
    'Quantity Change': 'Changement de Quantité',
    'Use negative number to reduce stock': 'Utilisez un nombre négatif pour réduire le stock',
    'Current Quantity:': 'Quantité Actuelle :',
    'Current Quantity': 'Quantité Actuelle',
    'Initial Quantity:': 'Quantité Initiale :',
    'Initial Quantity': 'Quantité Initiale',
    'Batch:': 'Lot :',
    'Batch': 'Lot',
    'Important': 'Important',
    'Adjusting batch quantity will automatically update the product stock. This action is logged and cannot be undone.': 'L\'ajustement de la quantité du lot mettra automatiquement à jour le stock de produit. Cette action est enregistrée et immuable.',
    'Select type': 'Sélectionner le type',
    'e.g., -10 to reduce, +5 to add': 'ex., -10 pour réduire, +5 pour ajouter',
    'Explain the reason for this adjustment...': 'Expliquez la raison de cet ajustement...',
    'Reference Number (Optional)': 'Numéro de Référence (Optionnel)',
    'e.g., RET-2024-001': 'ex., RET-2024-001',
    'Confirm Adjustment': 'Confirmer l\'Ajustement',
    'Batch History': 'Historique du Lot',
    'No history found': 'Aucun historique trouvé',
    'Quality': 'Qualité',
    'Quantity Available': 'Quantité Disponible',
    'Manufacturing Date': 'Date de Fabrication',
    'Active Batches': 'Lots Actifs',
    'Expired Batches': 'Lots Expirés',
    'Near Expiry': 'Proche de la Péremption',
    'Near Expiry (90 Days)': 'Proche de la Péremption (90 Jours)',
    'e.g., BATCH-2024-001': 'ex., BATCH-2024-001',
    'e.g., Shelf A1': 'ex., Étagère A1',
    'Active': 'Actif',
    'Inactive': 'Inactif',
    'Recalled': 'Rappelé',
    'Normal': 'Normal',
    'Expiring Soon': 'Bientôt périmé',
    'Expired': 'Périmé',
    'Depleted': 'Épuisé',
    'Edit Batch Details': 'Modifier les Détails du Lot',
    'Edit Batch': 'Modifier le Lot',
    'Available Stock': 'Stock Disponible',
    'Selling Price per Unit': 'Prix de Vente Unitaire',
    'Cost Price per Unit': 'Prix d\'Achat Unitaire',
    'Batch Status': 'Statut du Lot',
    'Recalled Status': 'Statut de Rappel',
    'Recall Reason': 'Motif du Rappel',
    'Notes / Remarks': 'Notes / Remarques',
    'Storage Location': 'Emplacement de Stockage',
    'Quality Status': 'Statut Qualité',
    'e.g., BCH32466': 'ex., BCH32466',
    'e.g., Shelf A2, Main Warehouse': 'ex., Étagère A2, Entrepôt Principal',
    'Specify manufacturer recall advisory or safety reason...': 'Spécifiez l\'avis de rappel du fabricant ou le motif de sécurité...',
    'Add any additional notes about this batch...': 'Ajoutez des notes supplémentaires sur ce lot...',
    'APPROVED': 'Approuvé',
    'PENDING': 'En attente',
    'QUARANTINE': 'Quarantaine',
    'REJECTED': 'Rejeté',
    'Please enter batch number': 'Veuillez saisir le numéro de lot',
    'Please select expiry date': 'Veuillez sélectionner la date de péremption',
    'Please enter cost price': 'Veuillez saisir le prix d\'achat',
    'Please provide recall reason': 'Veuillez indiquer la raison du rappel',
    'Failed to update batch': 'Échec de la mise à jour du lot',
    '30 Days': '30 Jours',
    '60 Days': '60 Jours',
    '90 Days': '90 Jours',
    '180 Days': '180 Jours',
    '1 Year': '1 An',
    'Adjust': 'Ajuster',
    'Clear': 'Vider',

    // ─── Employee Form Translations ─────────────────────────────────────
    'National ID / Passport #': 'N° Pièce d\'Identité / Passeport',
    'Operator / Technical Cert #': 'N° Certificat / Permis Opérateur',
    'Professional License #': 'N° Licence Professionnelle',
    'Medical / Council License #': 'N° Ordre Médical / Licence',
    'Employment Type': 'Type de contrat',
    'Emergency Contact Phone': 'Contact d\'Urgence',
    'Full-Time Permanent': 'Temps Plein Permanent',
    'Part-Time': 'Temps Partiel',
    'Contractual': 'Contractuel',
    'Locum / On-Call Doctor': 'Médecin En Garde',
    'Daily Contractor / Spool Operator': 'Opérateur Journalier / Bobines',
    'Seasonal / Temporary': 'Saisonnier / Temporaire',

    // ─── Dispensing, POS & Prescriptions Workspace ──────────────────────
    'Dispensing': 'Dispensation',
    'Dispense Medication': 'Délivrer le Médicament',
    'Pharmacy POS': 'Point de Vente Pharmacie',
    'Prescription Workspace': 'Espace Ordonnances',
    'CRITICAL CLINICAL ALERT': 'ALERTE CLINIQUE CRITIQUE',
    'Patient has registered allergy to': 'Le patient a une allergie enregistrée à',
    ' The following prescribed items match this allergy': ' Les médicaments prescrits suivants correspondent à cette allergie',
    'Patient Demographics': 'Démographie du Patient',
    'Patient ID / MRN': 'ID Patient / N° Dossier',
    'Full Name': 'Nom Complet',
    'Clinical Safety & History': 'Sécurité Clinique & Historique',
    'Drug Allergies': 'Allergies Médicamenteuses',
    'No chronic conditions reported': 'Aucune maladie chronique signalée',
    'No known drug allergies': 'Aucune allergie médicamenteuse connue',
    'Insurance Provider': 'Assureur',
    'Insurance Policy Number': 'Numéro de Police d\'Assurance',
    'Clinical Indication & Prescriber': 'Indication Clinique & Prescripteur',
    'Prescribing Doctor': 'Médecin Prescripteur',
    'License Number': 'Numéro de Licence',
    'Diagnosis / Clinical Notes': 'Diagnostic / Notes Cliniques',
    'No diagnosis provided': 'Aucun diagnostic fourni',
    'Prescription': 'Ordonnance',
    'Prescription Number': 'N° d\'Ordonnance',
    'Prescriber': 'Prescripteur',
    'Prescriber / Doctor': 'Prescripteur / Médecin',
    'Patient Name': 'Nom du Patient',
    'Patient Details': 'Détails du Patient',
    'Dosage Instructions': 'Posologie / Instructions',
    'Refill Count': 'Nombre de Renouvellements',
    'Dispensed Date': 'Date de Délivrance',
    'Dispensed By': 'Délivré Par',
    'Complete Sale': 'Finaliser la Vente',
    'Checkout': 'Caisse / Paiement',
    'Search by name, brand...': 'Rechercher par nom, marque...',
    'Scan Barcode / SKU...': 'Scanner Code-barres / SKU...',
    'Walk-in': 'Client de Passage',
    'Registered': 'Enregistré',
    'Enter name (optional)': 'Saisir le nom (optionnel)',
    'Phone number (optional)': 'Numéro de téléphone (optionnel)',
    'Click on a medication to add it': 'Cliquez sur un médicament pour l\'ajouter',

    // ─── Create Prescription ───────────────────────────────────────────
    'Prescribed Medications': 'Médicaments Prescrits',
    'No medications added. Click "Add Medication" to start.': 'Aucun médicament ajouté. Cliquez sur "Ajouter un Médicament" pour commencer.',
    'Diagnosis & Clinical Notes': 'Diagnostic & Notes Cliniques',
    'Diagnosis / Indications': 'Diagnostic / Indications',
    'e.g. Acute bacterial sinusitis': 'ex. Sinusite bactérienne aiguë',
    'Additional Directions / Notes': 'Directions Supplémentaires / Notes',
    'e.g. Take after meals, watch for allergic reactions...': 'ex. Prendre après les repas, surveiller les réactions allergiques...',
    'Patient Chart': 'Dossier Patient',
    'Register New Patient': 'Enregistrer un Nouveau Patient',
    'Prescribing Clinician': 'Clinicien Prescripteur',
    'Doctor Name': 'Nom du Médecin',
    'Prescription Date': 'Date de l\'Ordonnance',

    // ─── Patient History & Patient Form ───────────────────────────────
    'Registered:': 'Enregistré :',
    'Total Visits': 'Total des Visites',
    'TOTAL VISITS': 'TOTAL DES VISITES',
    'Outpatient encounters': 'Consultations externes',
    'Active Prescriptions': 'Ordonnances Actives',
    'ACTIVE PRESCRIPTIONS': 'ORDONNANCES ACTIVES',
    'Medications issued': 'Médicaments délivrés',
    'Medications Issued': 'Médicaments Délivrés',
    'Laboratory Requests': 'Demandes de Laboratoire',
    'LABORATORY REQUESTS': 'DEMANDES DE LABORATOIRE',
    'Diagnostic tests': 'Tests diagnostiques',
    'Latest Vitals Snapshot': 'Dernières Constantes',
    'LATEST VITALS SNAPSHOT': 'DERNIÈRES CONSTANTES',
    'Demographics & Vitals': 'Démographie & Constantes',
    'Male': 'Homme',
    'Female': 'Femme',
    'Medical Alerts & History': 'Alertes Médicales & Historique',
    'Waiting': 'En attente',
    'Contact Name': 'Nom du Contact',
    'Contact Phone': 'Téléphone du Contact',
    'Relationship': 'Lien de Parenté',
    'Medical Information': 'Informations Médicales',
    'Allergies': 'Allergies',
    'Medical Conditions': 'Affections Médicales',
    'Current Medications': 'Médicaments Actuels',
    'Insurance Information': 'Informations d\'Assurance',
    'Insurance Number': 'Numéro d\'Assurance',
    'Insurance Expiry': 'Expiration d\'Assurance',
    'Separate multiple allergies with commas': 'Séparer plusieurs allergies par des virgules',
    'Separate multiple conditions with commas': 'Séparer plusieurs affections par des virgules',
    'Separate multiple medications with commas': 'Séparer plusieurs médicaments par des virgules',
    'e.g., Hypertension, Diabetes, Asthma': 'ex., Hypertension, Diabète, Asthme',
    'e.g., Lisinopril 10mg daily, Metformin 500mg twice daily': 'ex., Lisinopril 10mg par jour, Metformine 500mg deux fois par jour',
    'Insurance company name': 'Nom de la compagnie d\'assurance',
    'Policy/Member number': 'Numéro de police / membre',
    'Update Patient': 'Mettre à jour le Patient',
    'Create Patient': 'Créer un Patient',
    'Register Patient': 'Enregistrer le Patient',

    // ─── Stock Management & Add Product Wizard ────────────────────────
    'Real-time inventory overview and multi-branch control': 'Aperçu de l\'inventaire en temps réel et contrôle multi-branches',
    'Search products by name, SKU or category...': 'Rechercher des produits par nom, SKU ou catégorie...',
    'Professional Stock Locations': 'Emplacements de Stock Professionnels',
    'Manage physical inventory across different warehouses, shelves, or store zones.': 'Gérer l\'inventaire physique à travers différents entrepôts, étagères ou zones de magasin.',
    'Add Location': 'Ajouter un Emplacement',
    'Create New Stock Location': 'Créer un Nouveau Stock',
    'Location Name': 'Nom de l\'Emplacement',
    'e.g. Warehouse A, Shelf 1, Front Desk': 'ex. Entrepôt A, Étagère 1, Accueil',
    'Type': 'Type',
    'Max Capacity': 'Capacité Maximale',
    'Internal Address/Notes': 'Adresse Interne/Notes',
    'e.g. Building B, Second Floor': 'ex. Bâtiment B, Deuxième Étage',
    'Create Location': 'Créer l\'Emplacement',
    'Assign Product to Main Stock': 'Assigner le Produit au Stock Principal',
    'Assign Product to': 'Assigner le Produit à',
    'Select Product': 'Sélectionner un Produit',
    'Search product...': 'Rechercher un produit...',
    'Quantity in this Location': 'Quantité dans cet Emplacement',
    "Note: This will update the product's total stock to reflect the new distribution.": "Note : Cela mettra à jour le stock total du produit pour refléter la nouvelle distribution.",
    'Assign Product': 'Assigner le Produit',
    'Edit Location': 'Modifier l\'Emplacement',
    'Products in Main Stock': 'Produits dans le Stock Principal',
    'Products in': 'Produits dans',
    'Search products in this location...': 'Rechercher des produits dans cet emplacement...',
    'TRANSFER QTY': 'QTÉ À TRANSFÉRER',
    'Transfer Qty': 'Qté à Transférer',
    'Transfer Stock Between Locations': 'Transférer du Stock entre Emplacements',
    'Source Location': 'Emplacement Source',
    'Destination Location': 'Emplacement de Destination',
    'Select destination': 'Sélectionner la destination',
    'Search products by name or SKU...': 'Rechercher des produits par nom ou SKU...',
    'Select Products to Transfer': 'Sélectionner les Produits à Transférer',
    'Complete Transfer': 'Finaliser le Transfert',
    'Combined Stock Distribution Report': 'Rapport de Distribution de Stock Combiné',
    'Add Products to Stock': 'Ajouter des Produits au Stock',
    'Add individual products manually or import multiple products from an Excel file': 'Ajouter des produits individuellement ou importer plusieurs produits depuis un fichier Excel',
    'Manual Entry': 'Saisie Manuelle',
    'Bulk Import': 'Importation En Masse',
    'Add New Product': 'Ajouter un nouveau produit',
    'Fill in the product details below to add it to your stock inventory': 'Remplissez les détails du produit ci-dessous pour l\'ajouter à votre inventaire de stock',
    'Product Type': 'Type de produit',
    'Please select product type': 'Veuillez sélectionner le type de produit',
    'Select product type': 'Sélectionner le type de produit',
    'General Product': 'Produit général',
    'Food': 'Nourriture',
    'Beverage': 'Boisson',
    'Retail': 'Vente au détail',
    'Service': 'Service',
    'Wholesale Price': 'Prix de gros',
    'Enter product name': 'Saisir le nom du produit',
    'Enter SKU': 'Saisir le SKU',
    'Enter barcode (optional)': 'Saisir le code-barres (optionnel)',

    // ─── Manage Stock Details Modal ──────────────────────────────────
    'Manage Stock Details': 'Gérer les Détails du Stock',
    'Manage stock by location, batch, and expiry. Each row represents a unique stock unit.': 'Gérer le stock par emplacement, lot et péremption. Chaque ligne représente une unité de stock unique.',
    'Current': 'Actuel',
    'CURRENT': 'ACTUEL',
    'Adjust (+/-)': 'Ajustement (+/-)',
    'ADJUST (+/-)': 'AJUSTEMENT (+/-)',
    'Final Qty': 'Qté Finale',
    'FINAL QTY': 'QTÉ FINALE',
    'Add New Stock Entry': 'Ajouter une Nouvelle Entrée de Stock',
    'Add Location Entry': 'Ajouter une Entrée d\'Emplacement',
    'Save Inventory': 'Enregistrer l\'Inventaire',
    'Delete this entry?': 'Supprimer cette entrée ?',
    'Total quantity will be updated from': 'La quantité totale sera mise à jour de',
    'to': 'à',

    // ─── Toast Notifications & Backend Error Messages ───────────────────
    'Success': 'Succès',
    'Error': 'Erreur',
    'Warning': 'Avertissement',
    'Info': 'Information',
    'Purchase order created successfully': 'Bon de commande créé avec succès',
    'Purchase order updated': 'Bon de commande mis à jour avec succès',
    'Purchase order updated successfully': 'Bon de commande mis à jour avec succès',
    'PO submitted for approval': 'Bon de commande soumis pour approbation',
    'PO approved': 'Bon de commande approuvé avec succès',
    'PO rejected': 'Bon de commande rejeté',
    'PO marked as ordered': 'Bon de commande marqué comme commandé',
    'Purchase order cancelled': 'Bon de commande annulé avec succès',
    'Failed to create PO': 'Échec de la création du bon de commande',
    'Failed to update PO': 'Échec de la mise à jour du bon de commande',
    'Failed to submit PO': 'Échec de la soumission du bon de commande',
    'Failed to process PO': 'Échec du traitement du bon de commande',
    'Failed to mark PO as ordered': 'Échec du marquage du bon de commande comme commandé',
    'Failed to cancel PO': 'Échec de l\'annulation du bon de commande',
    'GRN created successfully': 'Bon de réception créé avec succès',
    'GRN updated successfully': 'Bon de réception mis à jour avec succès',
    'Quality check completed': 'Contrôle qualité effectué avec succès',
    'GRN posted to inventory successfully': 'Bon de réception comptabilisé dans l\'inventaire avec succès',
    'Failed to create GRN': 'Échec de la création du bon de réception',
    'Failed to update GRN': 'Échec de la mise à jour du bon de réception',
    'Failed to perform quality check': 'Échec du contrôle qualité',
    'Failed to post GRN to inventory': 'Échec de la comptabilisation en stock du bon de réception',
    'Medication created successfully': 'Médicament créé avec succès',
    'Medication updated successfully': 'Médicament mis à jour avec succès',
    'Medication deleted successfully': 'Médicament supprimé avec succès',
    'Failed to create medication': 'Échec de la création du médicament',
    'Failed to update medication': 'Échec de la mise à jour du médicament',
    'Failed to delete medication': 'Échec de la suppression du médicament',
    'Batch created successfully': 'Lot créé avec succès',
    'Batch updated successfully': 'Lot mis à jour avec succès',
    'Batch adjusted successfully': 'Stock du lot ajusté avec succès',
    'Failed to create batch': 'Échec de la création du lot',
    'Failed to adjust batch': 'Échec de l\'ajustement du lot',
    'Stock transfer created successfully': 'Transfert de stock créé avec succès',
    'Stock transfer approved': 'Transfert de stock approuvé avec succès',
    'Stock transfer completed': 'Transfert de stock terminé avec succès',
    'Failed to create stock transfer': 'Échec de la création du transfert de stock',
    'Failed to process stock transfer': 'Échec du traitement du transfert de stock',
    'Smart Purchase Order Created': 'Bon de Commande Intelligent Créé',
    'Purchase order saved to database! Navigate to Purchase Orders to view.': 'Bon de commande enregistré dans la base de données ! Naviguez vers les Bons de Commande pour le consulter.',
    'No low stock items to order': 'Aucun médicament en faible stock à commander',
    'Are you sure you want to delete this medication?': 'Êtes-vous sûr de vouloir supprimer ce médicament ?',
    'Are you sure you want to submit this order for approval?': 'Êtes-vous sûr de vouloir soumettre cette commande pour approbation ?',
    'Please select a destination branch': 'Veuillez sélectionner une branche de destination',
    'Please select a supplier': 'Veuillez sélectionner un fournisseur',
    'Destination branch is required': 'La branche de destination est requise',
    'Supplier is required': 'Le fournisseur est requis',
    'Invalid quantity or unit cost': 'Quantité ou coût unitaire invalide',
    'Stock level below minimum threshold': 'Niveau de stock inférieur au seuil minimum',
    'Insufficient stock quantity': 'Quantité de stock insuffisante',

    // ─── Left Navbar Groups & Menu Items ──────────────────────────────────
    'PLATFORM CONTROL': 'CONTRÔLE DE LA PLATEFORME',
    'HARDWARE OPERATIONS': 'OPÉRATIONS MATÉRIELLES',
    'STAFF & PAYROLL': 'PERSONNEL & PAIE',
    'ADMINISTRATION': 'ADMINISTRATION',
    'OVERVIEW': 'APERÇU',
    'SALES & POS': 'VENTES & POS',
    'INVENTORY & SUPPLIERS': 'INVENTAIRE & FOURNISSEURS',
    'FLOOR & DISPLAY': 'SALLE & AFFICHAGE',
    'SERVICES & TOOLS': 'SERVICES & OUTILS',
    'CUSTOMERS & CREDIT': 'CLIENTS & CRÉDITS',
    'ANALYTICS & REPORTS': 'ANALYSES & RAPPORTS',
    'HMS COMMAND CENTER': 'CENTRE DE COMMANDEMENT HMS',
    'CLINICAL CARE (EMR)': 'SOINS CLINIQUES (DPI)',
    'DIAGNOSTICS & LABS': 'DIAGNOSTICS & LABORATOIRE',
    'HOSPITAL PHARMACY': 'PHARMACIE HOSPITALIÈRE',
    'BILLING & REVENUE': 'FACTURATION & REVENUS',
    'PHARMACY': 'PHARMACIE',
    'COFFEE SHOP': 'CAFÉ / COFFEE SHOP',
    'RESTAURANT': 'RESTAURANT',
    'BAR': 'BAR',
    'SHOP': 'BOUTIQUE',
    'OPERATIONS': 'OPÉRATIONS',
    'INVENTORY': 'INVENTAIRE',
    'CUSTOMERS': 'CLIENTS',
    'ANALYTICS': 'ANALYSES',
    'Stock & Medications': 'Stock & Médicaments',
    'Non-Medication Products': 'Produits Non-Médicamenteux',
    'Product Categories': 'Catégories de Produits',
    'Clinical Staff': 'Personnel Clinique',
    'Pharmacists': 'Pharmaciens',
    'Hospital Pharmacy POS': 'POS Pharmacie Hospitalière',
    'Hospital Pharmacy Dashboard': 'Tableau de Bord Pharmacie Hospitalière',
    'Pharmacy Dashboard': 'Tableau de Bord Pharmacie',
    'Prescriptions': 'Ordonnances',
    'Patients': 'Patients',
    'Staff Management': 'Gestion du Personnel',
    'Employees': 'Employés',
    'Payroll': 'Paie',
    'Executive Dashboard': 'Tableau de Bord Exécutif',
    'Footwear Catalog': 'Catalogue Chaussures',
    'Carton Pre-Packs': 'Cartons / Pre-Packs',
    'Brand Suppliers': 'Fournisseurs de Marques',
    'Display Audits': 'Audits d\'Affichage',
    'Mismatched Clearance': 'Dépareillés & Dégagement',
    'Care & Repair Orders': 'Entretien & Réparations',
    'Box Barcode Labels': 'Étiquettes Codes-barres Boîtes',
    'Size Converter': 'Convertisseur de Pointure',
    'Debts & Credit': 'Dettes & Crédits',
    'Sales Analytics': 'Analyses des Ventes',
    'Audit Logs': 'Journaux d\'Audit',
    'Spool & Stock Catalog': 'Catalogue Quincaillerie & Stock',
    'Stock Catalog': 'Catalogue Stock',
    'Tool & Equipment Rentals': 'Location d\'Outillage & Équipements',
    'Tool Rentals': 'Location d\'Outillage',
    'Contractors & Customers': 'Entrepreneurs & Clients',
    'Contractors & Clients': 'Entrepreneurs & Clients',
    'Contractor Credit & Debts': 'Crédits & Dettes Entrepreneurs',
    'Credit & Debts': 'Crédits & Dettes',
    'Funds & Ledger': 'Fonds & Grand Livre',
    'Operating Expenses': 'Dépenses d\'Exploitation',
    'Expenses': 'Dépenses',
    'Inventory Reports': 'Rapports d\'Inventaire',
    'Tables View': 'Vue des Tables',
    'New Order / POS': 'Nouvelle Commande / POS',
    'Bar POS': 'POS Bar',
    'Owner Dashboard': 'Tableau de Bord Propriétaire',
    'Clinical Director Console': 'Console Directeur Clinique',
    'Wholesale': 'Vente en Gros',
    'Sales History': 'Historique des Ventes',
    'Dashboard': 'Tableau de Bord',
    'Sales': 'Ventes',
    'Orders': 'Commandes',
    'Point of Sale': 'Point de Vente',

    // ─── Shoe Store & Metrics Section ──────────────────────────────────
    'Total Combined Revenue': 'Revenu Total Combiné',
    'Retail Asset Valuation': 'Évaluation des Actifs en Stock',
    'Gross Profit Margin': 'Marge Bénéficiaire Brute',
    'Registered Stock Models': 'Modèles de Stock Enregistrés',
    'Footwear sales + care service tickets': 'Ventes de chaussures + tickets d\'entretien',
    'Valuation across all registered pairs': 'Évaluation sur toutes les paires enregistrées',
    'Efficiency ratio across footwear lines': 'Ratio d\'efficacité sur la gamme de chaussures',
    'Active footwear matrix catalog': 'Catalogue actif de la matrice de chaussures',
    'Total Customers': 'Total des Clients',
    'Lifetime Footwear Spend': 'Dépenses Cumulées en Chaussures',
    'Shoe Care Service Clients': 'Clients de Service d\'Entretien',
    'Average Customer LTV': 'Valeur Client Moyenne (LTV)',
    'Registered buyers in directory': 'Acheteurs enregistrés dans le répertoire',
    'Total revenue generated by clients': 'Revenu total généré par les clients',
    'Customers using repair & care': 'Clients utilisant l\'entretien & réparation',
    'Average revenue generated per customer': 'Revenu moyen généré par client',
    'Total Orphaned Shoes': 'Total Chaussures Orphelines',
    'Unresolved Mix-ups': 'Mélanges Non Résolus',
    'Matched & Restocked': 'Appariées & Réapprovisionnées',
    'Clearance Asset Value': 'Valeur des Actifs en Dégagement',
    'Single Shoes': 'Chaussures Seules',
    'Single shoes': 'Chaussures seules',
    'Orphaned left/right single shoes logged': 'Chaussures seules gauche/droite enregistrées',
    'Pending matching or clearance sale': 'En attente d\'appariement ou de vente de dégagement',
    'Successfully paired back into inventory': 'Appariées avec succès et remises en stock',
    'Estimated discounted asset value': 'Valeur estimée des actifs remisés',
    'Total Display Audits': 'Total Audits d\'Affichage',
    'Active Floor Displays': 'Affichages de Salle Actifs',
    'Missing Shoes Alert': 'Alerte Chaussures Manquantes',
    'Audited Display Shoes': 'Chaussures d\'Affichage Auditées',
    'Audit records logged': 'Enregistrements d\'audit consignés',
    'Display racks being monitored': 'Présentoirs d\'affichage surveillés',
    'Single display shoes missing from rack': 'Chaussures d\'affichage manquantes du présentoir',
    'Total display shoes inspected': 'Total des chaussures d\'affichage inspectées',
    'Footwear Store Customers': 'Clients du Magasin de Chaussures',
    'Refresh Directory': 'Actualiser le Répertoire',
    'Add Customer': 'Ajouter un Client',
    'Footwear Sales & Financial Analytics': 'Analyses Financières & Ventes de Chaussures',
    'Export Report': 'Exporter le Rapport',
    'Refresh Reports': 'Actualiser les Rapports',
    'Export Audit PDF': 'Exporter le PDF d\'Audit',
    'Footwear Valuation & Audit Reports': 'Rapports d\'Évaluation & d\'Audit de Chaussures',
    'Shoe Box Barcode & End-Label Printer': 'Imprimante d\'Étiquettes & Codes-barres Boîtes',
    'Refresh Models': 'Actualiser les Modèles',
    'Print Labels': 'Imprimer les Étiquettes',
    'International Size Converter': 'Convertisseur de Pointure International',
    'Pre-Pack Carton Receiving': 'Réception de Cartons Pre-Pack',
    'Receive Shipment': 'Recevoir l\'Expédition',
    'Shoe Care & Restoration Services': 'Services d\'Entretien & Restauration de Chaussures',
    'New Service Ticket': 'Nouveau Ticket de Service',
    'Footwear Customer Debts & Credit': 'Dettes & Crédits Clients Chaussures',
    'Refresh Debts': 'Actualiser les Dettes',
    'Log Customer Debt': 'Enregistrer une Dette Client',
    'Footwear Sales History': 'Historique des Ventes de Chaussures',
    'Refresh History': 'Actualiser l\'Historique',
    'Mismatched & Single Shoes': 'Chaussures Dépareillées & Seules',
    'Log Mismatched Shoe': 'Enregistrer une Chaussure Dépareillée',
    'Customer Directory': 'Répertoire des Clients',
    'In Clearance': 'En Dégagement',
    'Paired Up': 'Appariée',
    'Written Off': 'Passée en Perte',
    'Refresh': 'Actualiser',
    'Total Outstanding Debt': 'Total Dette Impayée',
    'Active Debtors': 'Débiteurs Actifs',
    'Total Debt Records': 'Total Enregistrements de Dette',
    'Payment Protection': 'Protection de Paiement',
    'Uncollected customer balances': 'Soldes clients non recouvrés',
    'Distinct customers with unpaid balances': 'Clients distincts avec des soldes impayés',
    'Active & fully settled accounts': 'Comptes actifs et entièrement réglés',
    'Tracked directly via shoe_service': 'Suivi directement via le service de chaussures',
    'Pristine / Good': 'Parfait / Bon État',
    'Floor samples ready for customer try-ons': 'Échantillons prêts pour les essayages clients',
    'Scuffed / Wear': 'Rayé / Usé',
    'Requires polishing or replacement': 'Nécessite un polissage ou un remplacement',
    'Missing Floor Samples': 'Échantillons Manquants',
    'Discrepancy detected on display shelves': 'Écart détecté sur les étagères d\'affichage',
    'Active Care Orders': 'Commandes d\'Entretien Actives',
    'In Workshop': 'En Atelier',
    'Ready for Pickup': 'Prêt pour le Retrait',
    'Total Service Revenue': 'Revenu Total des Services',
    'Footwear left for repair & cleaning': 'Chaussures déposées pour réparation & nettoyage',
    'Currently undergoing refurbishment': 'En cours de rénovation',
    'Completed & awaiting customer pickup': 'Terminé & en attente de retrait client',
    'Combined service ticket billing': 'Facturation combinée des tickets de service',
    'Received Cartons': 'Cartons Reçus',
    'Total Footwear Pairs': 'Total Paires de Chaussures',
    'Unpacked & Stocked': 'Déballés & Mis en Stock',
    'Total Wholesale Cost': 'Coût Total de Gros',
    'Total bulk shipments received': 'Total des expéditions en vrac reçues',
    'Total units calculated via ratio matrix': 'Total des unités calculées via la matrice de ratios',
    'Populated into store inventory': 'Injectés dans l\'inventaire du magasin',
    'Total purchase order value': 'Valeur totale du bon de commande',
    'Pairs Sold': 'Paires Vendues',
    'Total Sales Txns': 'Total Transactions de Vente',
    'Average Order Value': 'Panier Moyen',
    'Combined gross footwear sales': 'Ventes brutes totales de chaussures',
    'Total shoes fulfilled': 'Total des chaussures livrées',
    'Completed checkout receipts': 'Reçus de caisse complétés',
    'Avg checkout basket total': 'Total moyen du panier de caisse',
    'Inventory Asset Audit': 'Audit des Actifs de Stock',
    'Retail Sales Audit': 'Audit des Ventes au Détail',
    'Care Workshop Audit': 'Audit de l\'Atelier d\'Entretien',
    'Total Model SKUs:': 'Total des SKUs Modèles :',
    'Total Pairs Stocked:': 'Total des Paires en Stock :',
    'Total Asset Value:': 'Valeur Totale des Actifs :',
    'Total Completed Transactions:': 'Total Transactions Complétées :',
    'Gross Footwear Revenue:': 'Revenu Brut des Chaussures :',
    'Total Model SKUs': 'Total des SKUs Modèles',
    'Total Pairs Stocked': 'Total des Paires en Stock',
    'Total Asset Value': 'Valeur Totale des Actifs',
    'Total Completed Transactions': 'Total Transactions Complétées',
    'Gross Footwear Revenue': 'Revenu Brut des Chaussures',
    'Shoe Care Workshop Clients': 'Clients de l\'Atelier d\'Entretien',
    'Total Client Sales Volume': 'Volume Total des Ventes Client',
    'Registered store buyers & care clients': 'Acheteurs & clients d\'entretien enregistrés',
    'Customers with cobbler tickets': 'Clients avec des tickets de cordonnier',
    'Avg revenue generated per client': 'Revenu moyen généré par client',
    'Cumulative footwear customer purchases': 'Achats cumulés des clients de chaussures',

    // ─── Hospital Owner Console / Clinical Director Console ─────────────────
    'Hospital Executive Overview': 'Aperçu Exécutif Hospitalier',
    'Hospital Executive Dashboard': 'Tableau de Bord Exécutif Hospitalier',
    'Total Patients': 'Total des Patients',
    'Registered across hospital directory': 'Enregistrés dans le répertoire de l\'hôpital',
    'Consultation Income': 'Revenus de Consultation',
    'Outpatient consultations & doctor fees': 'Consultations externes & honoraires médicaux',
    'Active Patient Queue': 'File d\'Attente Active Patients',
    'Patients in Triage & Consultation': 'Patients en Triage & Consultation',
    'Bed Occupancy Rate': 'Taux d\'Occupation des Lits',
    'Occupied ward beds / Total capacity': 'Lits d\'hospitalisation occupés / Capacité totale',
    'Hospital Revenue Streams': 'Flux de Revenus Hospitaliers',
    'Financial breakdown across departments': 'Ventilation financière par département',
    'Outpatient Consultations': 'Consultations Externes',
    'Diagnostics & Laboratory': 'Diagnostics & Laboratoire',
    'Hospital Pharmacy': 'Pharmacie Hospitalière',
    'Inpatient Wards & Stays': 'Salles d\'Hospitalisation & Séjours',
    'Emergency & Triage': 'Urgences & Triage',
    'Department Operational Status': 'Statut Opérationnel des Départements',
    'Real-time metrics across clinical units': 'Métriques en temps réel des unités cliniques',
    'Attending Doctor': 'Médecin Traitant',
    'MRN / Patient ID': 'N° Dossier / ID Patient',
    'Clinical Status': 'Statut Clinique',
    'Urgency': 'Urgence',
    'Encounters & Recent Admissions': 'Consultations & Admissions Récents',
    'Live patient queue & inpatient logs': 'File d\'attente en direct & registres des patients',
    'Triage Queue': 'File de Triage',
    'In Consultation': 'En Consultation',
    'Admitted to Ward': 'Admis en Hospitalisation',
    'Completed / Discharged': 'Terminé / Sorti',
    'Critical': 'Critique',
    'Routine': 'Routine',
    'New Patients (This Month)': 'Nouveaux Patients (Ce Mois)',
    'Consultations Today': 'Consultations Aujourd\'hui',
    'Average Queue Wait Time': 'Temps Moyen d\'Attente en File',
    'Occupied Beds': 'Lits Occupés',
    'Available Beds': 'Lits Disponibles',
    'Discharged Today': 'Sortis Aujourd\'hui',
    'Hospital Financials': 'Finances Hospitalières',
    'Appointments': 'Rendez-vous',
    'Patient Queue': 'File d\'Attente Patients',
    'Inpatient Wards': 'Salles d\'Hospitalisation',
    "Ambulance & Services d'Urgence": "Ambulance & Services d'Urgence",
    'Diagnostics PACS': 'PACS Diagnostics',
    'View Queue': 'Consulter la File',
    'Manage Wards': 'Gérer les Lits',
    'View Records': 'Consulter les Dossiers',
    'View All Patients': 'Voir Tous les Patients',
    'Hospital Performance': 'Performance Hospitalière',
    'Clinical & Operational Metrics': 'Métriques Cliniques & Opérationnelles',
    'Doctors on Duty': 'Médecins de Garde',
    'Total Clinical Revenue': 'Revenu Clinique Total',
    'Lab & Imaging Revenue': 'Revenu Labo & Imagerie',
    'Pharmacy Sales Revenue': 'Revenu Ventes Pharmacie',
    'Ward & Admission Revenue': 'Revenu Hospitalisation & Admissions',

    // ─── Extended Hospital Owner Console & Visualization ─────────────────
    'Multi-Branch Hospital Network': 'Réseau Hospitalier Multi-Branches',
    'Performance comparison across hospital locations': 'Comparaison de performance entre les sites hospitaliers',
    'Patients Treated': 'Patients Traités',
    'Bed Capacity': 'Capacité en Lits',
    'Insurance & Claims Overview': 'Aperçu Assurances & Recouvrements',
    'Pending claims & out-of-pocket revenue': 'Demandes en attente & revenus directs',
    'Pending Insurance Claims': 'Demandes d\'Assurance en Attente',
    'Private & National Insurance': 'Assurance Privée & Nationale',
    'Direct Cash Sales': 'Ventes Directes en Espèces',
    'Out-of-Pocket Patient Payments': 'Paiements Directs des Patients',
    'Uncollected Patient Debts': 'Dettes Patients Impayées',
    'Pending hospital billing accounts': 'Comptes de facturation hospitalière en attente',
    'Critical Drug Stockouts & Expiry': 'Ruptures de Médicaments & Expirations',
    'Hospital Pharmacy inventory alerts': 'Alertes d\'inventaire de la pharmacie hospitalière',
    'Medications Expiring Soon': 'Médicaments Proches de la Péremption',
    'Within 30-90 days': 'Dans les 30-90 jours',
    'Out of Stock Drugs': 'Médicaments en Rupture de Stock',
    'Immediate reorder required': 'Réapprovisionnement immédiat requis',
    'Medical Staff on Duty': 'Personnel Médical de Garde',
    'Doctors, Nurses, & Techs active on shift': 'Médecins, infirmiers & techniciens actifs de garde',
    'Medical Doctors': 'Médecins Spécialistes',
    'Active Nurses': 'Infirmiers Actifs',
    'Lab Technicians': 'Techniciens de Laboratoire',
    'Hospital Pharmacists': 'Pharmaciens Hospitaliers',
    'Daily Encounter & Visit Trends': 'Tendances des Consultations & Visites',
    'Daily outpatient & emergency patient volume': 'Volume quotidien des consultations externes & urgences',
    'OPD Encounters': 'Consultations Externes (OPD)',
    'Emergency Admissions': 'Admissions d\'Urgence',
    'Hospital Discharges': 'Sorties Hospitalières',
    'Overall Hospital Status': 'Statut Général de l\'Hôpital',
    'Optimal': 'Optimal',
    'High Activity': 'Activité Élevée',
    'Requires Attention': 'Attention Requise',

    // ─── World-Class HMS Executive Console Visualizations ─────────────────
    'Gross Hospital Revenue': 'Revenu Brut Hospitalier',
    'Average Length of Stay (ALOS)': 'Durée Moyenne de Séjour (DMS)',
    'Safety & Quality Score': 'Score de Sécurité & Qualité',
    'Insurance Claims & RCM': 'Demandes d\'Assurance & RCM',
    'Clinical Operations & Wards': 'Opérations Cliniques & Salles',
    'Financial & RCM Analytics': 'Analyses Financières & RCM',
    'Diagnostics & Pharmacy Supply Chain': 'Supply Chain Diagnostics & Pharmacie',
    'Payer Mix & Insurance Breakdown': 'Ventilation des Payeurs & Assurances',
    'Accounts Receivable & Aging Debts': 'Comptes Clients & Dettes Ancienneté',
    'Operating Theater (OT) & Surgeries': 'Bloc Opératoire & Chirurgie',
    'Inpatient Ward Capacity Breakdown': 'Ventilation de la Capacité des Lits',
    'ICU / Critical Care': 'Soins Intensifs / Réanimation',
    'Surgical Ward': 'Salle de Chirurgie',
    'General Medical Ward': 'Salle de Médecine Générale',
    'Pediatric Ward': 'Salle de Pédiatrie',
    'Maternity & Obstetrics': 'Maternité & Obstétrique',
    'Scheduled Surgeries Today': 'Chirurgies Programmées Aujourd\'hui',
    'Surgeries Completed': 'Chirurgies Effectuées',
    'Radiology & PACS Imaging': 'Radiologie & Imagerie PACS',
    'Pending Lab Samples': 'Échantillons de Laboratoire en Attente',
    'Critical Lab Values Alert': 'Alerte Valeurs Critiques de Laboratoire',
    'Controlled Substances Audit': 'Audit des Substances Contrôlées',
    'Claim Denial Rate': 'Taux de Rejet des Demandes',
    'Aging Debts (0-30 Days)': 'Dettes (0-30 Jours)',
    'Aging Debts (31-60 Days)': 'Dettes (31-60 Jours)',
    'Aging Debts (60+ Days)': 'Dettes (60+ Jours)',
    'Export Executive PDF': 'Exporter le PDF Exécutif',
    'Export Executive Excel': 'Exporter l\'Excel Exécutif',
    'Staff-to-Patient Ratio': 'Ratio Personnel / Patients',
    'Duty Roster': 'Planning de Garde',
    'On Shift': 'De Garde',
    'Gross Revenue': 'Revenu Brut',
    'Active Queue': 'File Active',
    'ALOS': 'DMS',
    'days': 'jours',
    'Beds': 'Lits',
    'No Criticals': 'Aucun Critique',
    'new': 'nouveau',
    'Prescriptions Dispensed Today': 'Ordonnances Dispensées Aujourd\'hui',
    'Beds Occupied': 'Lits Occupés',
    'Active Clinics': 'Cliniques Actives',
    'Processing Tests': 'Traitement d\'Analyses',
    'High Occupancy': 'Forte Occupation',
    'Operational': 'Opérationnel',
    'No branch data': 'Aucune donnée de branche',
    'No active clinical queue encounters': 'Aucun patient en consultation active',
    'Patient Directory': 'Répertoire des Patients',

    // ─── Comprehensive Hospital Administration & Settings ─────────────────
    'Hospital Settings & Administration': 'Paramètres & Administration Hospitalière',
    'Configure consultation tariffs, ward rates, triage protocols, insurance rules, and HMS policies': 'Configurer les tarifs de consultation, prix des lits, protocoles de triage, règles d\'assurance et politiques HMS',
    'Consultation Tariffs': 'Tarifs de Consultation',
    'Practitioner Roster': 'Planning des Praticiens',
    'Wards & Bed Rates': 'Salles & Tarifs des Lits',
    'Triage & ESI Protocol': 'Protocoles de Triage ESI',
    'Insurance & Co-Pay': 'Assurances & Tiers-Payant',
    'Pharmacy & Lab Policies': 'Politiques Pharmacie & Labo',
    'Facility Profile': 'Profil de l\'Établissement',
    'Fee Schedules Configured': 'Grilles Tarifaires Configurées',
    'Clinicians Scheduled': 'Praticiens au Planning',
    'Wards Configured': 'Salles Configurées',
    'ESI Triage SLA': 'SLA Triage ESI',
    'Payer Rules': 'Règles de Facturation',
    'Specialist Surcharges & Specialty Rates': 'Surcoûts Spécialistes & Tarifs Spécialisés',
    'General Practitioner (GP) OPD': 'Médecin Généraliste (OPD)',
    'Specialist Physician Consultation': 'Consultation Médecin Spécialiste',
    'Emergency & Out-of-Hours Duty Surcharge': 'Supplément Garde & Urgence de Nuit',
    'Pediatric & Neonatal Consultation': 'Consultation Pédiatrique & Néonatale',
    'Tele-Medicine & Remote Consultation': 'Télé-Médecine & Consultation à Distance',
    'Surcharge Amount': 'Montant du Surcoût',
    'Ward Category': 'Catégorie de Salle',
    'Daily Bed Rate': 'Tarif Journalier du Lit',
    'Ventilator Supported': 'Support Ventilateur',
    'Nursing Daily Care Fee': 'Frais Soins Infirmiers / Jour',
    'Total Bed Capacity': 'Capacité Totale en Lits',
    'Add Ward Category': 'Ajouter une Catégorie de Salle',
    'Emergency Severity Index (ESI) Protocols': 'Protocoles ESI (Emergency Severity Index)',
    'Configure target SLA response times and critical vital alerts for triage': 'Configurer les temps de réponse SLA cibles et alerte des constantes vitales',
    'Target SLA (Minutes)': 'SLA Cible (Minutes)',
    'Life-Saving Alert Trigger': 'Déclencheur d\'Alerte Vitale',
    'Auto-Escalate to Duty Doctor': 'Escalade Automatique vers le Médecin de Garde',
    'Life-threatening emergency (Immediate)': 'Urgence vitale immédiate (Immédiat)',
    'High risk, severe pain or confusion (< 15m)': 'Risque élevé, douleur sévère (< 15m)',
    'Multiple resources required (< 30m)': 'Ressources multiples requises (< 30m)',
    'Single resource required (< 60m)': 'Ressource unique requise (< 60m)',
    'No resources required (< 120m)': 'Aucune ressource requise (< 120m)',
    'Insurance Co-Pay & Payer Coverage Rules': 'Règles de Prise en Charge & Tiers-Payant',
    'Coverage Percentage': 'Pourcentage de Prise en Charge',
    'Patient Co-Pay Percentage': 'Pourcentage Co-Paiement Patient',
    'Pre-Authorization Limit': 'Plafond de Pré-Autorisation',
    'National Health Insurance (RSSB / RAMA)': 'Assurance Maladie Nationale (RSSB / RAMA)',
    'Community Health Insurance (Mutuelle)': 'Assurance Santé Communautaire (Mutuelle)',
    'Private Commercial Insurance': 'Assurance Privée Commerciale',
    'Direct Cash (100% Out-of-Pocket)': 'Comptant Direct (100% Patient)',
    'Hospital Pharmacy & Laboratory Policies': 'Politiques Pharmacie Hospitalière & Laboratoire',
    'Generic Drug Substitution': 'Substitution par Médicament Générique',
    'Automatic generic substitution allowed unless doctor specifies Brand Only': 'Substitution générique automatique autorisée sauf mention contraignante',
    'Controlled Substances Double-Sign': 'Double Signature Substances Contrôlées',
    'Require two licensed clinical signatures before dispensing narcotic medications': 'Exiger deux signatures cliniques autorisées avant dispensation d\'analgésiques/narcotiques',
    'STAT Emergency Lab Priority': 'Priorité Laboratoire d\'Urgence STAT',
    'Automatically flag emergency encounters for immediate lab processing (< 20 mins)': 'Marquer automatiquement les prélèvements d\'urgence pour analyse rapide (< 20 mins)',
    'Facility Administrative Info': 'Amakuru n\'Inyandiko z\'Ibitaro',
    'Hospital Facility Name': 'Nom de l\'Établissement Hospitalier',
    'Facility License / Accreditation Number': 'Numéro d\'Agrément / Licence Hospitalière',
    'Facility Level': 'Niveau de l\'Établissement',
    'National Referral Hospital': 'Hôpital National de Référence',
    'Regional Provincial Hospital': 'Hôpital Régional / Provincial',
    'District / Municipal Hospital': 'Hôpital de District / Municipal',
    'Polyclinic & Specialized Center': 'Polyclinique & Centre Spécialisé',
    'Emergency Hotline': 'Ligne Directe d\'Urgence',
    'Save All Hospital Settings': 'Enregistrer Tous les Paramètres Hospitaliers',
    'Hospital settings saved successfully': 'Paramètres hospitaliers enregistrés avec succès',
    'Add Insurance Payer Rule': 'Ajouter une Règle d\'Assurance',
    'Add Insurance Rule': 'Ajouter une Règle d\'Assurance',
    'Insurance Provider Name': 'Nom de l\'Assureur',
    'Add Specialty Consultation Rate': 'Ajouter un Tarif Spécialisé',
    'Add Specialty Rate': 'Ajouter un Tarif Spécialisé',
    'Specialty Title': 'Titre de la Spécialité',
    'Surcharge Fee': 'Frais de Surcoût',
    'No specialty surcharge rates configured.': 'Aucun tarif de surcoût spécialisé configuré.',
    'No insurance rules configured.': 'Aucune règle d\'assurance configurée.',
    'Insurance rule added': 'Règle d\'assurance ajoutée',
    'Specialty rate added': 'Tarif spécialisé ajouté',
    'Insurance rule deleted': 'Règle d\'assurance supprimée',
    'Specialty rate deleted': 'Tarif spécialisé supprimé',
    'Edit Ward Category': 'Modifier la Catégorie de Salle',
    'Save Changes': 'Enregistrer les Modifications',
    'Delete Ward Category?': 'Supprimer la Catégorie de Salle ?',
    'Ward deleted successfully': 'Salle supprimée avec succès',
    'Ward category updated successfully': 'Catégorie de salle mise à jour avec succès',
    'Ward Category Name': 'Nom de la Catégorie de Salle',
    'Ward Category Type': 'Type de Catégorie de Salle',
    'Standard Ward (General Care)': 'Salle Standard (Soins Généraux)',
    'ICU / Intensive Care (Réanimation)': 'Réanimation / Soins Intensifs (ICU)',
    'Surgical Ward (Chirurgie)': 'Salle de Chirurgie',
    'Pediatric & Neonatal (Pédiatrie)': 'Pédiatrie & Néonatologie',
    'Maternity & Obstetrics (Maternité)': 'Maternité & Obstétrique',
    'VIP & Executive Suite': 'Suite VIP & Exécutive',
    'Isolation & Infection Control': 'Unité d\'Isolement & Infectiologie',
    'Ventilator Support': 'Support Ventilateur',
    'Available': 'Disponible',
    'Not Available': 'Non Disponible',
    'Medical Acts, Surgeries & Specialty Tariffs': 'Tarifs des Actes Médicaux, Chirurgie & Spécialités',
    'Add Act / Procedure Tariff': 'Ajouter un Tarif d\'Acte / Chirurgie',
    'Add Medical Act or Surgical Tariff': 'Ajouter un Tarif d\'Acte Médical ou Chirurgie',
    'Edit Procedure / Act Tariff': 'Modifier le Tarif d\'Acte / Chirurgie',
    'Medical Act / Procedure Title': 'Titre de l\'Acte Médical / Chirurgie',
    'Tarif Total (Total Price)': 'Tarif Total',
    'Tiers Payant Share (%)': 'Part Tiers Payant (%)',
    'Ticket Modérateur Share (%)': 'Part Ticket Modérateur (%)',
    'Tarif Total': 'Tarif Total',
    'Tiers Payant': 'Tiers Payant',
    'Ticket Modérateur': 'Ticket Modérateur',
    'Description / Category': 'Description / Catégorie',
    'Initialize ESI Triage Protocol (Levels 1-5)': 'Initialiser le Protocole de Triage ESI (Niveaux 1-5)',
    'No ESI triage levels configured yet.': 'Aucun niveau de triage ESI configuré pour le moment.',
    'Operating Theater & Labs': 'Block Opératoire & Labos',
    'Ambulance & Mortuary': 'Ambulance & Morgue',
    'Tax & Fiscal Settings': 'Fiscalité & Taxes (NIF/TVA)',
    'Fiscal Tax Identification Number (NIF / TIN / IFU)': 'Numéro d\'Identification Fiscale (NIF / TIN / IFU)',
    'VAT / TVA Rate (%)': 'Taux TVA (%)',
    'Enable Standard VAT / TVA Tax Calculation': 'Activer le Calcul de la TVA sur la Facturation',
    'Advance Inpatient Admission Deposit': 'Acompte Obligatoire à l\'Admission (Dépôt)',
    'Invoice Terms & Legal Disclaimer': 'Conditions de Facturation & Mentions Légales',
    'Official Stamp / Accreditation Text': 'Texte du Cachet Officiel / Licence',
    'Operating Theater Hourly Rental Rate': 'Tarif Horaire Location Block Opératoire',
    'Anesthesia & SSPI Recovery Care Fee': 'Frais d\'Anesthésie & Salle de Réveil (SSPI)',
    'Ultrasound / Échographie Base Fee': 'Forfait Échographie (Ultrasound)',
    'X-Ray / Radiographie Digital Fee': 'Forfait Radiographie Numérique (X-Ray)',
    'CT Scan / Tomographie Base Fee': 'Forfait Scanner (CT Scan)',
    'Ambulance Base Dispatch Fee': 'Forfait Prise en Charge Ambulance',
    'Ambulance Transport Rate Per Kilometer': 'Tarif Ambulance au Kilometer (par km)',
    'Mortuary Preservation Daily Rate': 'Tarif Conservation Morgue (par jour)',
    'Emergency Registration Surcharge': 'Supplément Enregistrement d\'Urgence',
    'Tax & Fiscal Billing Settings': 'Paramètres Fiscaux & Taxe de Facturation',
    'Configure official tax numbers, VAT rates, inpatient deposit requirements, and invoice legal terms.': 'Configurer le NIF, le taux de TVA, l\'acompte d\'admission et les mentions légales des factures.',
    'Operating Theater & Diagnostic Act Tariffs': 'Tarifs Block Opératoire & Actes Diagnostiques',
    'Configure hourly surgery room rates, anesthesia fees, ultrasound, X-Ray, and lab act pricing.': 'Configurer la location du block opératoire, l\'anesthésie, les forfaits d\'échographie et de radiographie.',
    'Ambulance, Emergency & Mortuary Tariffs': 'Tarifs Ambulance, Urgences & Morgue',
    'Configure emergency dispatch fees, per-km ambulance rates, and mortuary preservation fees.': 'Configurer les frais de prise en charge ambulance, tarif au km et frais de conservation morgue.',
    'Save Fiscal Billing Settings': 'Enregistrer les Paramètres Fiscaux',
    'Save OT & Diagnostic Settings': 'Enregistrer les Tarifs Block Opératoire',
    'Save Emergency & Mortuary Settings': 'Enregistrer les Tarifs Urgences & Morgue',

    // ─── EMS & Ambulance Dispatch Page ───────────────────────────────
    'Emergency Medical Services (EMS) & Ambulance Dispatch': 'Services Médicaux d\'Urgence (SAMU) & Transports Ambulanciers',
    'Real-time emergency transfer logging, pre-hospital vitals tracking & mileage billing.': 'Suivi en temps réel des transferts d\'urgence, constantes préhospitalières & facturation au kilométrage.',
    'Hospital Reports & EMS Ledger': 'Rapports Hospitaliers & Journal SAMU',
    'Log Ambulance Run': 'Enregistrer une Intervention',
    'Total Dispatches': 'Total Interventions',
    'Total Distance Covered': 'Distance Totale Parcourue',
    'Total Ambulance Revenue': 'Revenu Total Ambulance',
    'Average Run Distance': 'Distance Moyenne / Trajet',
    'KM / Run': 'KM / Trajet',
    'Run': 'Trajet',
    'Search patient, vehicle #, driver, or dispatch ID...': 'Rechercher patient, véhicule #, chauffeur ou N° d\'intervention...',
    'Filter Status': 'Filtrer par Statut',
    'Completed': 'Terminé',
    'En Route': 'En Route',
    'Arrived at ER': 'Arrivé aux Urgences',
    'Dispatch ID & Urgency': 'N° Intervention & Urgence',
    'Patient & Crew': 'Patient & Équipage',
    'Trip Distance & Route': 'Distance & Trajet',
    'Vitals On Board': 'Constantes à Bord',
    'Total Charge': 'Total Facturé',
    'Run Sheet': 'Fiche d\'Intervention',
    'Send to ER Triage': 'Envoyer au Triage Urgences',
    'Driver': 'Chauffeur',
    'EMT': 'Secouriste / EMT',
    'Paramedic': 'Paramédical',
    'Incident': 'Lieu de l\'Incident',
    'Scene': 'Lieu de Prise en Charge',
    'ER Bay': 'Box des Urgences',
    'BP': 'PA',
    'Pulse': 'Pouls',
    'Emergent': 'Urgent',
    'Log Emergency Ambulance Dispatch Run': 'Enregistrer une Intervention Ambulancière d\'Urgence',
    'Edit Ambulance Dispatch Run': 'Modifier l\'Intervention Ambulancière',
    'Save & Send to ER Triage': 'Enregistrer & Envoyer au Triage',
    'Save & Update Dispatch Record': 'Enregistrer les Modifications',
    'Log & Auto-Bill Run': 'Valider & Facturer l\'Intervention',
    'Ambulance Vehicle Number': 'Numéro d\'Immatriculation Véhicule',
    'Select Vehicle': 'Sélectionner le Véhicule',
    'Dispatch Type': 'Type d\'Intervention',
    'Urgency Level': 'Niveau de Priorité / Urgence',
    'Origin Location / Scene': 'Lieu de Prise en Charge / Origine',
    'Destination ER Bay / Hospital': 'Destination / Service des Urgences',
    'Start Odometer (KM)': 'Compteur de Départ (KM)',
    'End Odometer (KM)': 'Compteur d\'Arrivée (KM)',
    'Pre-Hospital Vitals Recorded On Board': 'Constantes Vitales Préhospitalières Relevées à Bord',
    'BP Systolic': 'PA Systolique',
    'BP Diastolic': 'PA Diastolique',
    'Pulse (BPM)': 'Pouls (BPM)',
    'SpO2 (%)': 'SpO2 (%)',
    'Auto-Calculated Billing Summary (From Settings)': 'Récapitulatif Financier Calculé Automatiquement (Selon Paramètres)',
    'Enter Trip Distance / Mileage': 'Saisir la Distance du Trajet / Kilométrage',
    'Calculates Mileage Fee dynamically': 'Calcule automatiquement les frais kilométriques',
    'Base Dispatch Fee:': 'Forfait Prise en Charge:',
    'Mileage Fee:': 'Frais Kilométriques:',
    'Emergency Registration Surcharge:': 'Supplément Enregistrement Urgence:',
    'Total Charge:': 'Montant Total Facturé:',
    'TOTAL CHARGE BILLED:': 'TOTAL DE LA FACTURE:',
    'Ambulance Run Sheet & Audit Log': 'Fiche de Log & Registre SAMU',
    'Print Run Sheet': 'Imprimer la Fiche',
    'Close': 'Fermer',
    'Patient & Dispatch Profile': 'Profil Patient & Signalement',
    'Dispatch Type & Urgency': 'Type d\'Urgence & Gravité',
    'Vehicle & Crew Assignment': 'Véhicule & Équipage Assigné',
    'Vehicle # & Driver': 'N° Véhicule & Chauffeur',
    'EMT Paramedic Crew': 'Équipage Paramédical / EMT',
    'Pre-Hospital Vitals Logged': 'Relevé des Constantes Vitales',
    'Quick Register Emergency Patient': 'Inscription Rapide d\'un Patient d\'Urgence',
    'Register Driver / EMT Staff Crew': 'Enregistrer un Chauffeur / Paramédical',
    'Qualified Ambulance Drivers & Transport Staff': 'Chauffeurs Ambulanciers Qualifiés & Transport',
    'Paramedics, EMTs & ER Medical Crew': 'Paramédicaux, Infirmiers & Secouristes EMT',
    'All Hospital Personnel': 'Tout le Personnel Hospitalier',
  },
  rw: {
    'Medical Acts, Surgeries & Specialty Tariffs': 'Ibiciro by\'Ibibando, Kubaga & Ubuvuzi bw\'Abarwayi',
    'Add Act / Procedure Tariff': 'Ongeramo Igiciro cy\'Ibibando / Kubaga',
    'Add Medical Act or Surgical Tariff': 'Ongeramo Igiciro cy\'Ibibando / Kubaga',
    'Edit Procedure / Act Tariff': 'Hindura Igiciro cy\'Ibibando / Kubaga',
    'Medical Act / Procedure Title': 'Izina ry\'Igibando / Kubaga',
    'Tarif Total (Total Price)': 'Igiciro Rusange (Total)',
    'Tiers Payant Share (%)': 'Igice cy\'Ubwishingizi (%)',
    'Ticket Modérateur Share (%)': 'Igice cy\'Umurwayi (%)',
    'Tarif Total': 'Igiciro Rusange',
    'Tiers Payant': 'Ubwishingizi',
    'Ticket Modérateur': 'Umurwayi',
    'Description / Category': 'Ibisobanuro / Ikiciro',
    'Initialize ESI Triage Protocol (Levels 1-5)': 'Gushyiraho Amabwiriza y\'Ubutabazi y\'Ibitaro (Niveau 1-5)',
    'No ESI triage levels configured yet.': 'Nta mabwiriza y\'ubutabazi arashyirwaho.',
    'Operating Theater & Labs': 'Icyumba cyo Kubagira & Laboratwari',
    'Ambulance & Mortuary': 'Imbangukiragutabara & Inzu y\'Abapfuye',
    'Tax & Fiscal Settings': 'Imisoro & Inyandiko z\'Ibitaro',
    'Fiscal Tax Identification Number (NIF / TIN / IFU)': 'Numero y\'Umusoro (NIF / TIN)',
    'VAT / TVA Rate (%)': 'Igihembo cy\'Umusoro (TVA %)',
    'Enable Standard VAT / TVA Tax Calculation': 'Fungura Umusoro ku Inyandiko z\'Kwishyura (TVA)',
    'Advance Inpatient Admission Deposit': 'Avansi Isabwa mu Kwinjira mu Bitaro',
    'Invoice Terms & Legal Disclaimer': 'Amabwiriza y\'Inyandiko y\'Kwishyura',
    'Official Stamp / Accreditation Text': 'Inyandiko y\'Ikasi ry\'Ibitaro',
    'Operating Theater Hourly Rental Rate': 'Igiciro ku Isaha cyo Gukoresha Icyumba cyo Kubagira',
    'Anesthesia & SSPI Recovery Care Fee': 'Igiciro cy\'Ibiganzure & Kwita ku Waba Waza',
    'Ultrasound / Échographie Base Fee': 'Igiciro cy\'Igisuzuma cy\'Échographie',
    'X-Ray / Radiographie Digital Fee': 'Igiciro cy\'Igisuzuma cy\'Iminyonzi (X-Ray)',
    'CT Scan / Tomographie Base Fee': 'Igiciro cy\'Igisuzuma cy\'Ikyuma (CT Scan)',
    'Ambulance Base Dispatch Fee': 'Igiciro cy\'Imbangukiragutabara',
    'Ambulance Transport Rate Per Kilometer': 'Igiciro cy\'Imbangukiragutabara ku Kilometero',
    'Mortuary Preservation Daily Rate': 'Igiciro cyo Kubika Umurambo ku Munsi',
    'Emergency Registration Surcharge': 'Igiciro cyo Kwandika Abarwayi b\'Ubwihutirwe',
    'Tax & Fiscal Billing Settings': 'Paramètres Fiscaux & Taxe de Facturation',
    'Configure official tax numbers, VAT rates, inpatient deposit requirements, and invoice legal terms.': 'Gushyiraho numero y\'umusoro, TVA, n\'amabwiriza y\'inyandiko z\'kwishyura.',
    'Operating Theater & Diagnostic Act Tariffs': 'Tarifs Block Opératoire & Actes Diagnostiques',
    'Configure hourly surgery room rates, anesthesia fees, ultrasound, X-Ray, and lab act pricing.': 'Gushyiraho igiciro cyo kubagira, ibikoresho, n\'ibisuzuma vya Laboratwari.',
    'Ambulance, Emergency & Mortuary Tariffs': 'Tarifs Ambulance, Urgences & Morgue',
    'Configure emergency dispatch fees, per-km ambulance rates, and mortuary preservation fees.': 'Gushyiraho igiciro cy\'imbangukiragutabara n\'inzu y\'abapfuye.',
    'Save Fiscal Billing Settings': 'Bika Amabwiriza y\'Imisoro',
    'Save OT & Diagnostic Settings': 'Bika Ibiciro byo Kubagira',
    'Save Emergency & Mortuary Settings': 'Bika Ibiciro by\'Imbangukiragutabara',
    // ─── Technical Pharmacy Terms in Kinyarwanda ──────────────────────
    'Medication': 'Umuti',
    'Medications': 'Imiti',
    'Medication Inventory': 'Ububiko bw\'Imiti',
    'Add Medication': 'Ongeramo Umuti',
    'New Medication': 'Umuti Mushya',
    'Edit Medication': 'Hindura Umuti',
    'Delete Medication': 'Siba Umuti',
    'Import Medications': 'Kwinjiza Imiti',
    'Generic Name': 'Izina Ryagutse ry\'Umuti',
    'Brand Name': 'Izina ry\'Uruganda',
    'Dosage Form': 'Ubwoko bw\'Umuti (Forme)',
    'Strength': 'Ingano y\'Umuti (Strength)',
    'Therapeutic Category': 'Ikiciro cy\'Umuti',
    'Active Ingredient': 'Akarango k\'Umuti (Active Ingredient)',
    'Barcode / SKU': 'Kode y\'Umuti / SKU',
    'SKU': 'Kode / SKU',
    'Unit of Measure': 'Igereranyo',
    'Units': 'Ibipimo',
    'Cost Price': 'Igiciro cyo Kugura',
    'Selling Price': 'Igiciro cyo Kugurisha',
    'Unit Cost': 'Igiciro cy\'Igipimo',
    'Unit Price': 'Igiciro cy\'Igipimo',
    'Cost Per Unit': 'Igiciro cy\'Igipimo',
    'Cost/Unit': 'Igiciro/Igipimo',
    'Prescription Required': 'Bisaba Inyandiko ya Muganga (Rx)',
    'Over The Counter (OTC)': 'Umuti wo Kugura Bitagose Inyandiko (OTC)',
    'Purchase Orders': 'Inyandiko z\'Ibyaguzwe (Purchase Orders)',
    'Purchase Order': 'Inyandiko y\'Ibyaguzwe',
    'New Purchase Order': 'Inyandiko Nshya y\'Ibyaguzwe',
    'Create Purchase Order': 'Kurema Inyandiko y\'Ibyaguzwe',
    'Order & Supplier Information': 'Amakuru y\'Ibyaguzwe & Umuguzi',

    // ─── Hardware Store Management Translations ───────────────────────────
    'Hardware Store': 'Magasin de Quincaillerie',
    'Hardware Store Executive Dashboard': 'Tableau de Bord Exécutif Quincaillerie',
    'Executive Dashboard': 'Tableau de Bord Exécutif',
    'Real-time operational metrics, cable spool stock, tool rentals, and contractor credit tracking': 'Métriques opérationnelles en temps réel, stock de tourets de câbles, location d\'outils et suivi de crédit entrepreneurs',
    'Manage Equipment Rentals': 'Gérer les Locations d\'Équipement',
    'Refresh': 'Actualiser',
    'Inventory Asset Value': 'Valeur du Stock d\'Inventaire',
    'INVENTORY ASSET VALUE': 'VALEUR DU STOCK D\'INVENTAIRE',
    'Active Spools Count': 'Nombre de Tourets Actifs',
    'ACTIVE SPOOLS COUNT': 'NOMBRE DE TOURETS ACTIFS',
    'Active Tool Rentals': 'Locations d\'Outils Actives',
    'ACTIVE TOOL RENTALS': 'LOCATIONS D\'OUTILS ACTIVES',
    'Total Rental Revenue': 'Revenu Total des Locations',
    'TOTAL RENTAL REVENUE': 'REVENU TOTAL DES LOCATIONS',
    'Total Rental Earnings': 'Gains Totaux de Location',
    'TOTAL RENTAL EARNINGS': 'GAINS TOTAUX DE LOCATION',
    'TOTAL RENTAL RECORDS': 'TOTAL DES ENREGISTREMENTS',
    'TOTAL HARDWARE SKUS': 'TOTAL SKUS QUINCAILLERIE',
    'CUT-TO-LENGTH SPOOLS': 'TOURETS DE COUPE À LA LONGUEUR',
    'TOTAL STOCK ASSET VALUATION': 'VALEUR TOTALE DU STOCK',
    'ACTIVE EQUIPMENT RENTALS': 'LOCATIONS D\'ÉQUIPEMENTS ACTIVES',
    'ACTIVE SECURITY DEPOSITS': 'DÉPÔTS DE GARANTIE ACTIFS',
    'Outstanding Contractor Debts': 'Dettes Entrepreneurs en Cours',
    'Hardware Operations Command': 'Commande des Opérations de Quincaillerie',
    'HARDWARE OPERATIONS COMMAND': 'COMMANDE DES OPÉRATIONS DE QUINCAILLERIE',
    'Hardware POS': 'Caisse POS Quincaillerie',
    'Stock Catalog': 'Catalogue des Stocks',
    'Spool & Stock Catalog': 'Catalogue de Tourets & Stocks',
    'Hardware Spool & Stock Catalog': 'Catalogue de Tourets & Stocks Quincaillerie',
    'Dynamic inventory catalog, spool stock levels, profit margin calculation, and custom categories': 'Catalogue d\'inventaire dynamique, niveaux de tourets, calcul des marges et catégories personnalisées',
    'Tool Rentals': 'Locations d\'Outils',
    'Tool & Equipment Rentals': 'Location d\'Outillage & Équipements',
    'Manage machinery checkout, daily rental rates, security deposits, and tool return inspections': 'Gérer la sortie de machines, les tarifs journaliers, les dépôts de garantie et les retours',
    'Contractors & Debts': 'Entrepreneurs & Dettes',
    'Contractors & Clients': 'Entrepreneurs & Clients',
    'Contractor Accounts': 'Comptes Entrepreneurs',
    'Financial Analytics': 'Analyses Financières',
    'Sales Analytics': 'Analyses des Ventes',
    'Recent Operational Audit Stream': 'Flux d\'Audit Opérationnel Récent',
    'Action & Event Details': 'Détails de l\'Action & Événement',
    'ACTION & EVENT DETAILS': 'DÉTAILS DE L\'ACTION & ÉVÉNEMENT',
    'Staff / Operator': 'Personnel / Opérateur',
    'STAFF / OPERATOR': 'PERSONNEL / OPÉRATEUR',
    'Timestamp': 'Horodatage',
    'TIMESTAMP': 'HORODATAGE',
    'entries': 'entrées',
    'No audit events recorded yet': 'Aucun événement d\'audit enregistré pour le moment',

    // ─── POS & Unit / Category Badges ─────────────────────────────────────
    'Cut Spool': 'Touret de Coupe',
    'Cut to Length': 'Coupé à la Longueur',
    'Meter': 'Mètre',
    'meter': 'mètre',
    'meters': 'mètres',
    'Bag': 'Sac',
    'bag': 'sac',
    'bags': 'sacs',
    'pcs': 'pièces',
    'Pcs': 'Pièces',
    'Unit': 'Unité',
    'unit': 'unité',
    'Cost': 'Coût',
    'Masonry, Cement & Building Supplies': 'Maçonnerie, Ciment & Matériaux de Construction',
    'Electrical Cables & Wiring Spools': 'Câbles Électriques & Tourets de Fil',
    'Tool & Machinery Rental Services': 'Services de Location d\'Outils & Machines',
    'Electrical': 'Électricité',
    'Masonry': 'Maçonnerie',

    // ─── Catalog Table & Header Actions ───────────────────────────────────
    'Add Hardware Item': 'Ajouter un Article Quincaillerie',
    'Add Category': 'Ajouter une Catégorie',
    'Item & Category': 'Article & Catégorie',
    'ITEM & CATEGORY': 'ARTICLE & CATÉGORIE',
    'Stock Level': 'Niveau du Stock',
    'STOCK LEVEL': 'NIVEAU DU STOCK',
    'Pricing & Margin': 'Prix & Marge',
    'PRICING & MARGIN': 'PRIX & MARGE',
    'Quick Actions': 'Actions Rapides',
    'ACTIONS RAPIDES': 'ACTIONS RAPIDES',
    'Restock PO': 'Réappro PO',
    'Cut': 'Couper',
    'Search part #, item name, category...': 'Rechercher n° de pièce, nom, catégorie...',
    'Search equipment, serial #, contractor...': 'Rechercher équipement, n° de série, entrepreneur...',

    // ─── Tool Rental Modal & Table Headers ────────────────────────────────
    'Checkout Equipment': 'Louer un Équipement',
    'Checkout Equipment / Tool Rental': 'Location d\'Équipement & Outillage',
    'Register customer checkout, daily rate, security deposit & rental duration': 'Enregistrer la location, le tarif journalier, la caution et la durée',
    'Equipment & Tool Identification': 'Identification d\'Équipement & Outillage',
    'EQUIPMENT & TOOL IDENTIFICATION': 'IDENTIFICATION D\'ÉQUIPEMENT & OUTILLAGE',
    'Contractor Details & Rental Terms': 'Détails de l\'Entrepreneur & Conditions',
    'CONTRACTOR DETAILS & RENTAL TERMS': 'DÉTAILS DE L\'ENTREPRENEUR & CONDITIONS',
    'Tool / Equipment Name': 'Nom de l\'Outil / Équipement',
    'Serial Number / ID': 'Numéro de Série / ID',
    'Contractor / Customer Name': 'Nom de l\'Entrepreneur / Client',
    'Customer Phone': 'Téléphone du Client',
    'Daily Rate': 'Tarif Journalier',
    'Security Deposit': 'Dépôt de Garantie',
    'Rental Duration (Days)': 'Durée de Location (Jours)',
    // ─── Contractor / Customer Modal & Table Headers ───────────────────────
    'Company / Contractor Name': 'Nom de l\'Entreprise / Entrepreneur',
    'Contractor Name': 'Nom de l\'Entrepreneur',
    'Phone Number': 'Numéro de Téléphone',
    'Email Address': 'Adresse E-mail',
    'Contractor Trade Category': 'Catégorie d\'Activité de l\'Entrepreneur',
    'Trade Category': 'Catégorie d\'Activité',
    'Register Contractor Credit Line': 'Enregistrer une Ligne de Crédit Entrepreneur',
    'Record material credit balances and trade accounts for contractors': 'Enregistrer les soldes de crédit de matériaux et les comptes clients',
    'Contractor Profile': 'Profil de l\'Entrepreneur',
    'Credit Agreement & Stock Materials': 'Accord de Crédit & Matériaux en Stock',
    'Catalog Stock Items (Auto-Deduct Stock)': 'Articles du Stock Catalogue (Déduction Auto)',
    'Custom / Manual Credit Entry': 'Saisie Manuelle de Crédit',
    'Articles Catalogue': 'Articles Catalogue',
    'Saisie Manuelle': 'Saisie Manuelle',
    'Rechercher un article...': 'Rechercher un article...',
    'Select Inventory Catalog Item': 'Sélectionner un Article du Stock Catalogue',
    'Search & add stock catalog item...': 'Rechercher & ajouter un article du stock...',
    'Credit Description / Material Summary': 'Description du Crédit / Résumé des Matériaux',
    'Total Amount Due': 'Montant Total Dû',
    'Notes & Payment Terms': 'Notes & Conditions de Paiement',
    'Confirm Credit Registration': 'Confirmer l\'Enregistrement du Crédit',
    'Register Contractor': 'Enregistrer un Entrepreneur',
    'Register New Trade Contractor': 'Enregistrer un Nouvel Entrepreneur',
    'Directory profile, trade category & credit line limit': 'Profil de répertoire, catégorie d\'activité & limite de crédit',
    'Edit Contractor Profile & Credit Limit': 'Modifier le Profil & Limite de Crédit',
    'Update Profile': 'Mettre à jour le Profil',
    'Payment History': 'Historique des Paiements',
    'No payment history records found': 'Aucun enregistrement d\'historique de paiement trouvé',
    'Close': 'Fermer',
    'General Contractor': 'Entrepreneur Général',
    'Electrical Specialist': 'Spécialiste Électrique',
    'Plumbing Specialist': 'Spécialiste Plomberie',
    'Masonry & Civil': 'Maçonnerie & Génie Civil',
    'Estimated Total Contract Charge:': 'Frais Totaux Estimés du Contrat :',
    'Deposit Held': 'Caution Détenue',
    'Deposit Held:': 'Caution Détenue :',
    'Confirm Checkout': 'Confirmer la Location',
    'Equipment / Tool': 'Équipement / Outil',
    'EQUIPMENT / TOOL': 'ÉQUIPEMENT / OUTIL',
    'Contractor / Customer': 'Entrepreneur / Client',
    'CONTRACTOR / CUSTOMER': 'ENTREPRENEUR / CLIENT',
    'Rental Rates & Deposit': 'Tarifs & Dépôt',
    'RENTAL RATES & DEPOSIT': 'TARIFS & DÉPÔT',
    'Status & Actions': 'Statut & Actions',
    'STATUS & ACTIONS': 'STATUT & ACTIONS',
    'Active Equipment Rentals': 'Locations d\'Équipements Actives',
    'Active Security Deposits': 'Dépôts de Garantie Actifs',
    'Total Rental Records': 'Total Enregistrements de Location',
    'Returned & Inspected': 'Retourné & Inspecté',
    'Currently Rented': 'En Cours de Location',
    'Returned': 'Retourné',
    'All Statuses': 'Tous les Statuts',
    'All Equipment & Machinery': 'Tous les Équipements & Machines',
    'Select contractor or type customer name...': 'Sélectionner un entrepreneur ou saisir le nom...',
    'Select or type equipment name...': 'Sélectionner ou saisir le nom de l\'équipement...',
    'Process Return': 'Traiter le Retour',
    'Tool Return Inspection': 'Inspection de Retour d\'Outil',
    'day': 'jour',
    'days': 'jours',
    'Deposit': 'Caution',
    'Deposit:': 'Caution :',

    // ─── Hardware Roles & Departments ────────────────────────────────────
    'Hardware Store Manager': 'Directeur de Magasin de Quincaillerie',
    'Electrical & Cable Spool Specialist': 'Spécialiste Tourets Câbles & Électricité',
    'Building Supplies & Masonry Clerk': 'Employé Matériaux de Construction & Maçonnerie',
    'Tool & Equipment Rental Manager': 'Responsable Location d\'Outils & Équipements',
    'Spool Cutting & Measuring Operator': 'Opérateur de Coupe & Mesurage de Tourets',
    'Hardware POS Cashier & Billing Clerk': 'Caissier POS & Facturation Quincaillerie',
    'Contractor Account Specialist': 'Spécialiste Comptes Entrepreneurs',
    'Heavy Delivery Driver & Loader': 'Chauffeur de Livraison Lourd & Chargeur',
    'Store Security & Maintenance': 'Sécurité & Maintenance du Magasin',

    'Hardware POS & Storefront Billing': 'Caisse POS Quincaillerie & Facturation',
    'Contractor Credit & Debts Ledger': 'Registre de Crédit & Dettes Entrepreneurs',
    'Warehouse, Stock Control & Logistics': 'Entrepôt, Contrôle des Stocks & Logistique',
    'Operator / Technical Cert #': 'N° Certificat Technique / Opérateur',
    'Daily Contractor / Spool Operator': 'Entrepreneur Journalier / Opérateur Touret',

    // ─── Spool Cutting & Debts Ledger Terms ──────────────────────────────
    'Cut Cable / Pipe Spool': 'Couper le Touret de Câble / Tuyau',
    'Total Initial Length': 'Longueur Initiale Totale',
    'Remaining Length': 'Longueur Restante',
    'Length to Cut': 'Longueur à Couper',
    'Price per Meter': 'Prix par Mètre',
    'Total Cut Amount': 'Montant Total Coupé',
    'Confirm Spool Cut': 'Confirmer la Coupe du Touret',
    'Stock Type': 'Type de Stock',
    'Inventory Level': 'Niveau de Stock',
    'Reorder Threshold': 'Seuil de Réapprovisionnement',
    'Batch / Heat Number': 'N° de Lot / Coulée',
    'Spool Serial': 'N° de Série du Touret',

    'Contractor Credit Ledger': 'Grand Livre de Crédit Entrepreneurs',
    'Total Debt Outstanding': 'Total Dette en Cours',
    'Total Credit Paid': 'Total Crédit Payé',
    'Clear Debt Payment': 'Payer / Épurer la Dette',
    'Payment Amount': 'Montant du Paiement',
    'Payment Method': 'Mode de Paiement',
    'Cash': 'Espèces',
    'Bank Transfer': 'Virement Bancaire',
    'Mobile Money': 'Mobile Money',
    'Cheque': 'Chèque',
    'Paid:': 'Payé :',
    'Scrap:': 'Chute :',
    'POS Sale': 'Vente Caisse POS',
    'Cut Stock Logged': 'Coupe de Touret Enregistrée',
    'Walk-in Customer': 'Client de Passage',
    'Walk-in Buyer': 'Acheteur de Passage',
    'Contractors & Trade Customers': 'Entrepreneurs & Clients Professionnels',
    'Add Hardware Catalog Item': 'Ajouter un Article au Catalogue Quincaillerie',
    'Register a new SKU, wire spool stock, or building material to inventory': 'Enregistrer un nouveau SKU, touret de fil ou matériau de construction dans l\'inventaire',
    'Item Identification & Category': 'Identification de l\'Article & Catégorie',
    'ITEM IDENTIFICATION & CATEGORY': 'IDENTIFICATION DE L\'ARTICLE & CATÉGORIE',
    'Part # / SKU Code': 'N° de Pièce / Code SKU',
    'PART # / SKU CODE': 'N° DE PIÈCE / CODE SKU',
    'Part # / SKU is required': 'Le n° de pièce / SKU est requis',
    'Item Name': 'Nom de l\'Article',
    'ITEM NAME': 'NOM DE L\'ARTICLE',
    'Item name is required': 'Le nom de l\'article est requis',
    'Unit of Measure (UOM)': 'Unité de Mesure (UDM)',
    'UNIT OF MEASURE (UOM)': 'UNITÉ DE MESURE (UDM)',
    'Stock Type & Inventory Control': 'Type de Stock & Contrôle d\'Inventaire',
    'STOCK TYPE & INVENTORY CONTROL': 'TYPE DE STOCK & CONTRÔLE D\'INVENTAIRE',
    'Inventory Stock Type': 'Type de Stock d\'Inventaire',
    'INVENTORY STOCK TYPE': 'TYPE DE STOCK D\'INVENTAIRE',
    'Standard Discrete Unit Stock': 'Stock Unitaire Standard',
    '📦 Standard Discrete Unit Stock': '📦 Stock Unitaire Standard',
    'Cut-to-Length Wire / Spool Stock': 'Stock de Touret / Fil de Coupe',
    '✂️ Cut-to-Length Cable / Hose Spool': '✂️ Touret de Câble / Tuyau de Coupe',
    'Initial Stock Qty / Spool Length': 'Quantité de Stock Initiale / Longueur du Touret',
    'INITIAL STOCK QTY / SPOOL LENGTH': 'QUANTITÉ DE STOCK INITIALE / LONGUEUR DU TOURET',
    'Pricing & Financial Margins': 'Prix & Marges Financières',
    'PRICING & FINANCIAL MARGINS': 'PRIX & MARGES FINANCIÈRES',
    'Cost Price per Unit': 'Prix d\'Achat Unitaire',
    'COST PRICE PER UNIT': 'PRIX D\'ACHAT UNITAIRE',
    'Selling / Retail Price': 'Prix de Vente / Détail',
    'SELLING / RETAIL PRICE': 'PRIX DE VENTE / DÉTAIL',
    'Save Hardware Item': 'Enregistrer l\'Article Quincaillerie',
    'Meter (m)': 'Mètre (m)',
    'Kilogram (kg)': 'Kilogramme (kg)',
    'Piece / Unit (pcs)': 'Pièce / Unité (pcs)',
    'Unit / Piece (pcs)': 'Unité / Pièce (pcs)',
    'Bag / Sack (50kg)': 'Sac (50kg)',
    'Box / Carton (box)': 'Boîte / Carton (boîte)',
    'Roll / Spool (roll)': 'Rouleau / Touret (rouleau)',
    'Manage Business Categories': 'Gérer les Catégories d\'Activité',
    'Organize hardware stock, spools, machinery, and building materials into dynamic categories': 'Organiser le stock de quincaillerie, tourets, machines et matériaux en catégories dynamiques',
    'Create New Category': 'Créer une Nouvelle Catégorie',
    'Category Name': 'Nom de la Catégorie',
    'Category Description': 'Description de la Catégorie',
    'Create Category': 'Créer la Catégorie',
    'Update Category': 'Mettre à jour la Catégorie',
    'Category Directory': 'Répertoire des Catégories',
    'CATEGORY DIRECTORY': 'RÉPERTOIRE DES CATÉGORIES',
    'Search categories...': 'Rechercher des catégories...',
    'POS Sales Transactions History': 'Historique des Ventes POS',
    'Vente POSs Transactions History': 'Historique des Ventes POS',
    'Category Sales Revenue Distribution': 'Répartition des Ventes par Catégorie',
    'METER': 'MÈTRE',
    'UNIT': 'UNITÉ',
    'Search hardware items by SKU, name, category...': 'Rechercher par SKU, nom, catégorie...',
    'Search hardware items by SKU, name,...': 'Rechercher par SKU, nom...',
    'Export CSV Report': 'Exporter le Rapport CSV',
    'All Catalog Inventory & Asset Valuation': 'Tout l\'Inventaire & Valorisation des Stocks',
    'Cut-to-Length Cable & Pipe Spools': 'Tourets de Câble & Tuyau de Coupe',
    'Asset Valuation & Rate': 'Valorisation du Stock & Tarif',
    'ASSET VALUATION & RATE': 'VALORISATION DU STOCK & TARIF',
    'Spool Value & Rate': 'Valeur du Touret & Tarif',
    'Rate': 'Tarif',
    'Rate:': 'Tarif:',
    'Cable & Spool Cut-to-Length Calculator': 'Calculateur de Coupe de Câble & Touret',
    'Current Spool Stock': 'Stock Actuel du Touret',
    'Remaining After Cut': 'Reste Après Coupe',
    'Spool Capacity Remaining': 'Capacité Restante du Touret',
    'Requested Cut Length': 'Longueur de Coupe Demandée',
    'Unit Rate': 'Tarif Unitaire',
    'Optional Scrap / Waste Length': 'Chute / Déchet Optionnel',
    'Calculated Cut Price': 'Prix de Coupe Calculé',
    'Cut & Add to Order': 'Couper & Ajouter à la Commande',
    'Electrical Cable': 'Câble Électrique',
    'Custom': 'Personnalisée',
    'System Standard': 'Standard Système',
    'Hose Spool': 'Touret de Tuyau',
    'Brass fittings': 'Raccords en laiton',
    'Power cables, wire spools, conduits, switches ...': 'Câbles d\'alimentation, tourets de fil, conduits, interrupteurs ...',
    'PVC pipes, copper tubing, brass valves, coupli...': 'Tuyaux PVC, tubes en cuivre, vanne laiton, raccordement ...',
    'Drills, saws, grinders, compressors & generato...': 'Perceuses, meuleuses, compresseurs & générateurs ...',
    'Portland cement, sand, gravel, rebar, bricks & ...': 'Ciment Portland, sable, gravier, barres de fer, briques & ...',
    'Portland Cement 42.5N (50kg Bag)': 'Ciment Portland 42.5N (Sac de 50kg)',
    'Portland Cement 42.5N': 'Ciment Portland 42.5N',
    'Hardware Contractor Credit & Debts': 'Crédit & Dettes Entrepreneurs Quincaillerie',
    'Track trade professional credit lines, building material debts, and payment records': 'Suivre les lignes de crédit des professionnels, les dettes de matériaux et les paiements',
    'Register Contractor Credit': 'Enregistrer un Crédit Entrepreneur',
    'OUTSTANDING CONTRACTOR DEBTS': 'DETTES ENTREPRENEURS EN COURS',
    'TOTAL RECOVERED CREDIT': 'CRÉDIT RECOUVRÉ TOTAL',
    'Total Recovered Credit': 'Crédit Recouvré Total',
    'TOTAL CREDIT RECORDS': 'TOTAL DES ENREGISTREMENTS DE CRÉDIT',
    'Total Credit Records': 'Total Enregistrements de Crédit',
    'Search contractor, phone, credit type...': 'Rechercher un entrepreneur, téléphone, type de crédit...',
    'Search contractor, ph...': 'Rechercher un entrepreneur, téléphone...',
    'Search contractor or debt...': 'Rechercher entrepreneur ou dette...',
    'All Credit Records': 'Tous les Enregistrements',
    'Unpaid Balances': 'Soldes Impayés',
    'Fully Settled': 'Entièrement Réglé',
    'Tous': 'Tous',
    'Impayés': 'Impayés',
    'Réglés': 'Réglés',
    'Credit Type / Item': 'Type de Crédit / Article',
    'CREDIT TYPE / ITEM': 'TYPE DE CRÉDIT / ARTICLE',
    'Outstanding Due': 'Solde Dû',
    'OUTSTANDING DUE': 'SOLDE DÛ',
    'Building Supplies': 'Matériaux de Construction',
    'Directory of registered builders, electricians, plumbers, and trade professionals': 'Annuaire des constructeurs, électriciens, plombiers et professionnels du bâtiment enregistrés',
    'Registered Trade Contractors': 'Entrepreneurs Enregistrés',
    'Contractors With Active Debts': 'Entrepreneurs avec Dettes Actives',
    'Total Contractor Sales': 'Ventes Totales aux Entrepreneurs',
    'Trade Type': 'Secteur d\'Activité',
    'Total Orders': 'Total des Commandes',
    'Total Purchases': 'Achats Totaux',
    'Credit Limit': 'Limite de Crédit',
    'Active Debt': 'Dette Active',
    'Action': 'Action',
    'Commande': 'Commande',
    'Commandes': 'Commandes',
    '🧱 Concrete Mixer Machine (5.5 HP Diesel)': '🧱 Bétonnière (5.5 HP Diesel)',
    'Concrete Mixer Machine (5.5 HP Diesel)': 'Bétonnière (5.5 HP Diesel)',
    '⚡ Portable Silent Generator (10 KVA)': '⚡ Générateur Silencieux Portable (10 KVA)',
    'Portable Silent Generator (10 KVA)': 'Générateur Silencieux Portable (10 KVA)',
    '💥 Heavy Demolition Breaker / Jackhammer (1500W)': '💥 Marteau Piqueur / Démolisseur Lourd (1500W)',
    'Heavy Demolition Breaker / Jackhammer (1500W)': 'Marteau Piqueur / Démolisseur Lourd (1500W)',
    '🔨 Vibratory Plate Compactor / Rammer': '🔨 Plaque Vibrante Compacteuse / Pilonneuse',
    'Vibratory Plate Compactor / Rammer': 'Plaque Vibrante Compacteuse / Pilonneuse',
    '📐 Professional 3D Laser Rotary Level': '📐 Niveau Laser 3D Professionnel',
    'Professional 3D Laser Rotary Level': 'Niveau Laser 3D Professionnel',
    '🌊 Commercial High-Pressure Washer (250 Bar)': '🌊 Nettoyeur Haute Pression Commercial (250 Bar)',
    'Commercial High-Pressure Washer (250 Bar)': 'Nettoyeur Haute Pression Commercial (250 Bar)',
    '✂️ Heavy Steel Bar Cutter & Bender Saw': '✂️ Cisaillouse & Cintreuse d\'Acier Lourde',
    'Heavy Steel Bar Cutter & Bender Saw': 'Cisaillouse & Cintreuse d\'Acier Lourde',
    '🪜 Heavy-Duty Modular Scaffold Tower Set': '🪜 Échafaudage Modulaire Professionnel',
    'Heavy-Duty Modular Scaffold Tower Set': 'Échafaudage Modulaire Professionnel',

    // ─── Hardware Bulk Excel Import Translations ───────────────────────────
    'Import Hardware Catalog (Excel / CSV)': 'Importer le Catalogue Quincaillerie (Excel / CSV)',
    'Register multiple hardware items, cables, and spools in batch': 'Enregistrer des articles, câbles et tourets quincaillerie en lot',
    'Instructions for Bulk Import': 'Instructions pour l\'Importation en Lot',
    'Download our sample template, fill in your hardware stock details, and re-upload the file below.': 'Téléchargez notre modèle d\'exemple, remplissez vos détails de stock quincaillerie et téléversez le fichier ci-dessous.',
    'Need a sample spreadsheet template?': 'Besoin d\'un modèle de feuille de calcul d\'exemple ?',
    'Includes sample rows for cables, cement, tools, and pipes': 'Comprend des exemples de lignes pour câbles, ciment, outils et tuyaux',
    'Download Excel Template': 'Télécharger le Modèle Excel',
    'Click or drag Excel / CSV file to upload': 'Cliquez ou glissez un fichier Excel / CSV à téléverser',
    'Supports .xlsx, .xls, and .csv files containing bulk hardware inventory': 'Prend en charge les fichiers .xlsx, .xls et .csv contenant le stock',
    'Items to Import': 'Articles à Importer',
    'Spool Tourets': 'Tourets de Coupe',
    'Total Import Valuation': 'Valeur Totale de l\'Import',
    'Parsed Hardware Items Preview': 'Aperçu des Articles Quincaillerie Extraits',
    'Clear & Reupload File': 'Effacer & Téléverser à nouveau',
    'Importing Hardware Catalog...': 'Importation du Catalogue Quincaillerie...',
    'Start Bulk Import': 'Démarrer l\'Importation Groupée',
    'Sample Excel template downloaded successfully': 'Modèle d\'exemple Excel téléchargé avec succès',
    'valid hardware items extracted successfully': 'articles quincaillerie valides extraits avec succès',
    'The uploaded file is empty or formatted incorrectly.': 'Le fichier téléversé est vide ou incorrectement formaté.',
    'Please upload Excel (.xlsx, .xls) or CSV files only': 'Veuillez téléverser uniquement des fichiers Excel (.xlsx, .xls) ou CSV',
    'Part #': 'N° Réf',
    'Article': 'Article & Catégorie',
    'Import Excel': 'Importer via Excel',
  }
};
